import { Autocomplete, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, InputAdornment, MenuItem, Popover, Popper, Select, TextField, Tooltip } from '@mui/material';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { CleanConversationHistory, LoadCustomAttributeDefinitions, LoadTemplates, LoadSecureFiles, HandlePushConversation, UpdateOptInCollectedMessage } from '../../actions';
import Config from '../../config';
import { deleteDraftMessage, getDraftMessage, setDraftMessage } from '../../helpers/conversations-draft.helper';
import { buildCronExpression } from '../../helpers/cron-expression.builder';
import setToast from '../../helpers/toaster.helper';
import { CampaignModel, Contact, ConversationModel, DeliveryStatus, Group, GroupChatModel, MediaModel, TypeAction } from '../../models/conversations';
import { ScheduleMessageType, SecureScheduleMessageType } from '../../models/conversations/schedule-messages.model';
import { MediaFileType, MediaType } from "../../models/media.models";
import { OrgPlanTracker, PlanMetrics, UserPlanTracker } from '../../models/plan-metrics.model';
import { SettingsModel } from '../../models/settings-model';
import { TemplateModel } from '../../models/templates.models';
import { CustomAttributeDefinitionModel } from '../../models/custom-attribute.model';
import { UserModel } from '../../models/users.model';
import { ProfileModel } from '../../models/profile.model';
import { AppState } from '../../reducers/models';
import { ContactService } from '../../services/ContactService';
import { MessageService } from '../../services/MessageService';
import { SettingsService } from '../../services/SettingsService';
import { UserService } from '../../services/UserService';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from '../shared/button/button.component';
import { appNote, AppTags, buildCustomAttributeTags, buildResolvedTags, buttonLabels, ContactTags, DialogHeaders, Tags, ToasterTexts, UserTags } from '../shared/constants';
import DateAndTimePicker from '../shared/datetimepicker/date-timepicker.component';
import Audio from "../shared/media/audio.component";
import File from "../shared/media/file.component";
import ImageComponent from '../shared/media/image.component';
import Video from "../shared/media/video.component";
import Mentions from "../shared/mentions";
import InternalNoteComposer from './internal-note-composer';
import { computeLength, mapTextToDescendants } from '../shared/mentions/models';
import { ToasterType } from '../shared/toaster/toaster.model';
import Emojis from './emojis';
import {
    MediaDefaultIcon, ResetIcon, SendNewMsgIcon, SendWhiteIcon,
    ComposerHelpCircleIcon, EmojiActiveIcon, ComposerSmileIcon, ComposerAttachmentIcon, ComposerSignatureIcon, ComposerTagsIcon, ComposerNotesIcon, ComposerNotesActiveIcon, ComposerTemplateIcon, FileActiveIcon,
    LinkActiveIcon, LinkDiableIcon, SignatureActiveIcon, TagsActiveIcon, TemplateActiveIcon, AlarmActive, ComposerTimerIcon, CancelIcon, FaceAuthenticationIcon,
    FaceRegistrationIcon, FaceAuthenticationHoverIcon,
    SearchIconSec,
    PdfIcon,
    MediaTxtIcon,
    WordIcon,
    XlsIcon,
    ZipIcon,
    SecureChatInviteGreyIcon,
    SecureChatInviteActiveIcon,
    SecureChatActiveIcon,
    SuggestedRepliesBoxCancelIcon,
    MessageToneIcon,
    MessageLengthIon,
    MessageTranslateIcon,
    MessageImproveIcon,
    MessageFriendlyIcon,
    MessageCasualIcon,
    MessageEmpatheticIcon,
    MessageFormalIcon,
    MessagePlayfulIcon,
    RefineMessageActiveButtonicon,
    RefineMessageDisableButtonicon,
    RefineMessageUndoicon,
    RefineMessageComposerActiveicon,
    RefineMessageComposerDisableicon,
    MessageImprovePurpleIcon,
    MessageTonePurpleIcon,
    MessageLengthPurpleIcon,
    MessageTranslatePurpleIcon,
    AICancelIcon,
    MessageImprovePurpleDark,
    InfoCircleIcon,
    GridSearchIcon,
    SearchButtonClearedIcon,
    ComposerEsignTemplateIcon,
} from '../../icon'
import { FaceAuthenticationModel, FaceRegistrationInviteLinkStatus, SecureFileModel } from '../../models/secure-file'
import { v4 as uuid } from "uuid";
import moment from 'moment'
import { Dispatch } from '@reduxjs/toolkit'
import CustomTooltip from './CustomTooltip '
import SecureFilePopoverComponent from './securefile-popover.component';
import { SecureChatService } from '../../services/SecureChatService';
import AnimateLoaderComponent from '../shared/loaders/animate-loader.component';
import SecureChatMediaUploading from "../shared/loaders/secure-chat-media-uploading.json";
import _, { size } from 'lodash';

import falkonAiMessageGeneratingLoader from "../shared/loaders/falkon-ai-message-genearating-loader.json";
import { FalkonAiService } from '../../services/FalkonAiService';
import { FileService } from '../../services/FileService';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';
import FalkonesignPopOverComponent from './falkon-esign-templates-pop-over.component';

type ScheduleOption = {
    Name: string;
    Value: SecureScheduleMessageType | ScheduleMessageType;
};
let ScheduleTypes: ScheduleOption[] = [
    { Name: "One time", Value: ScheduleMessageType.ONE_TIME }
    , { Name: "Daily", Value: ScheduleMessageType.DAILY }
    , { Name: "Weekly", Value: ScheduleMessageType.WEEKLY }
    , { Name: "Every 2 weeks", Value: ScheduleMessageType.EVERY_2_WEEKS }
    , { Name: "Monthly", Value: ScheduleMessageType.MONTHLY }
    , { Name: "Every 6 months", Value: ScheduleMessageType.EVERY_6_MONTHS }
    , { Name: "Every year", Value: ScheduleMessageType.EVERY_YEAR }
];

let SecureScheduleTypes: ScheduleOption[] = [
    { Name: "One time", Value: SecureScheduleMessageType.ONE_TIME }
    , { Name: "Daily", Value: SecureScheduleMessageType.DAILY }
    , { Name: "Weekly", Value: SecureScheduleMessageType.WEEKLY }
    , { Name: "Monthly", Value: SecureScheduleMessageType.MONTHLY }
];

let debounceTimer;
const debounce = (callback, time) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(callback, time);
}

interface IStateProps {
    IsMobileDevice: boolean;
    DeviceWidth: number;
    DeviceHeight: number;
    PlanMetrics: PlanMetrics;
    Contacts: Contact[];
    Groups: Group[];
    Templates: TemplateModel[];
    SignatureSettings: SettingsModel;
    GetUnSubscribedContacts: Contact[];
    SecureFile: SecureFileModel[];
    UnscbscribedConversations: ConversationModel[];
    FaceAuthenticationFiles: FaceAuthenticationModel[];
    FalkonWebSocket: WebSocket;
    History: { [key: string]: ConversationModel[] };
    isDarkMode: boolean;
    IsNewOrgFlow: boolean
    UserPlanTracker: UserPlanTracker
    OrgPlanTracker: OrgPlanTracker
    Conversations: ConversationModel[];
    OptInCollectedMessage: string;
    customAttributeFields: CustomAttributeDefinitionModel[];
    Users: UserModel[];
    OrganizationName: string;
}

interface IProps extends IStateProps {
    className?: string;
    PhoneNumber?: string;
    PhoneNumbers?: string[];
    Display?: string;
    IsNewMessage?: boolean;
    IsAddRule?: boolean;
    GroupIDs?: string[];
    ContactIDs?: string[];
    HandleClose?: (success?: boolean) => void;
    HandleChange?: (data: { body: string, media: MediaModel[], bodyLength: number, characterLimit?: number }) => void;
    IsDisabled?: boolean;
    UniqId?: string;
    IsUnsubscribe?: boolean;
    Limit: number;
    UnsubscribedCount?: number;
    BlockedCount?: number;
    style?: any;
    ShowScheduleType?: boolean;
    Message?: string;
    ScheduleType?: number;
    ScheduleDateTime?: number;
    ScheduleEndDateTime?: number;
    ScheduledMessageID?: string;
    IsDuplicate?: boolean;
    IsAddTemplate?: boolean;
    HandleScheduleTypeChange?: (isScheduleMessage: boolean) => void;
    showSignature?: boolean;
    GroupChat?: GroupChatModel;
    IsGroupChat?: boolean;
    bodySign?: string;
    signLength?: number;
    handleSuccess?: () => void
    setIsMobileSchedule?: (x: boolean) => void
    dispatch: Dispatch;
    TemplateErrorMessage?: any;
    Campaign?: CampaignModel;
    IsCamPaign: boolean;
    IsAfterHours?: boolean;
    AfterHoursClick?: () => void;
    IsAfterHoursActive?: boolean;
    SuggestionMessage?: string;
    IsSecureChat?: boolean;
    ParticipantId?: string;
    MultiMedia?: MediaModel[];
    IsOptInCollected?: boolean;
}

interface IState {
    SelectedScheduleType: number;
    show: boolean;
    cancel: boolean;
    isTemplate: boolean;
    body: string;
    errorText: string;
    bodyLength: number;
    mediaUploading: { Name: string, Status: boolean };
    emoji: string;
    openTags: boolean;
    anchorEl: null;
    [x: number]: any;
    showScheduleType: boolean;
    ScheduleDateTime: number;
    ScheduleEndDateTime: number;
    sendingNewMessage: boolean;
    showTemplates: boolean;
    searchInput: string;
    anchorTemplate: Element | null;
    ShowMoreOptions: boolean;
    bodySign: string;
    defaultSign: string;
    showSign?: boolean;
    signLength: number;
    ShowBottomDrawer: boolean;
    anchorSecureFile: Element | null;
    onEmojiHover: boolean;
    onFileHove: boolean;
    onTagsHover: boolean;
    onTemplateHover: boolean;
    onSecureFileHover: boolean;
    onSignatureHover: boolean;
    showCalnder: boolean;
    anchorEmjoi: Element | null;
    onScheduleHover: boolean;
    isDragging?: boolean;
    onFaceAuthenticationHover: boolean;
    anchorFaceAuthentication: Element | null;
    faceRegistrationInviteLinkStatus: FaceRegistrationInviteLinkStatus;
    sendInviteLoading: boolean;
    onSecureChatHover: boolean;
    secureChatPopover: boolean;
    secureChatAnchor: Element | null;
    onEsignHover: boolean;
    EsignPopover: boolean;
    characterLimit: number;
    popoverAnchor: { top: number; left: number } | null;
    isGSM: boolean;
    displayCharacterLimit: number;

    aiFeaturesPopUp: boolean;
    falkonAiMessageRefineFeatures: { Name: string, Active: boolean }[];
    falkonAiMessageLength: "Shorten" | "Expand" | "";
    messageTone: string;
    language: string;
    falkonAiMessage: string;
    aiAnimation: boolean;
    openTagsInAi: boolean;
    aiFeaturesAnchor: Element | null;
    originalMessage: string;
    onAiFeaturesHover: boolean;
    onNotesHover: boolean;
    internalNoteMode: boolean;
    files: { file: any, size: number, media: MediaModel }[];
    sendOptInRequest: boolean;
}

const CreditsRequried = (limit: number, chars: number, parts: number, totalCredits: number, unsubscribedCount: number, blockedCount: number, IsGroupChat, IsAddTemplate: boolean, IsAddRule: boolean) => (

    <Fragment>
        <ul className={"h6-regular f-w-bold p-1"}>
            {
                IsAddTemplate ? <>
                    <li>Number of characters in the message = {chars}</li>
                    <li>Number of parts in which message will be sent = {parts}</li>
                    <li>Each multimedia image takes 3 credits</li>
                </> : IsAddRule ? <>
                    <li>Number of characters in the message = {chars}</li>
                    <li>Number of parts in which message will be sent = {parts}</li>
                    <li>Each multimedia image takes 3 credits</li>
                    <li>{IsGroupChat || limit > 1 ? "Group" : "1-1"} Credits Required Calculation = {totalCredits} </li>
                </> :
                    <>
                        <li>Number of contacts added {IsGroupChat ? "in Group Chat" : ""} = {IsGroupChat ? limit : limit + unsubscribedCount} </li>
                        <li>Number of characters in the message = {chars}</li>
                        <li>Number of parts in which message will be sent = {parts}</li>
                        <li>Each multimedia image takes 3 credits</li>
                        {!IsGroupChat && (limit + unsubscribedCount) === 1 ? <li>Is Unsubscribed = {!!unsubscribedCount ? "True" : "False"}</li> : !IsGroupChat && <li>Number of unsubscribers in the group = {unsubscribedCount}</li>}
                        {!IsGroupChat && (limit + unsubscribedCount) === 1 ? <li>Is Blocked = {!!blockedCount ? "True" : "False"}</li> : !IsGroupChat && <li>Number of blocked contacts in the group = {blockedCount}</li>}
                        <li>{IsGroupChat || limit > 1 ? "Group" : "1-1"} Credits Required Calculation = {totalCredits} </li>
                    </>
            }
        </ul>
    </Fragment>
)

class MessageComposer extends Component<IProps, IState> {
    recentTypingEvent: TypeAction = TypeAction.STOP_TYPING;
    constructor(props: IProps) {
        super(props);
        const draftedMessage = (this.props.GroupChat?.PhoneNumbers && this.props.GroupChat?.PhoneNumbers.length > 0) ? getDraftMessage(this.props.GroupChat?.PhoneNumbers[0] || "") : (this.props.PhoneNumbers && this.props.PhoneNumbers.length > 0) ? getDraftMessage(this.props.PhoneNumbers[0] || "") : "";
        const message = this.props.Message ? this.props.Message : (this.props.PhoneNumbers || this.props.GroupChat?.PhoneNumbers) ? draftedMessage : "";
        this.state = {
            show: false,
            isTemplate: false,
            cancel: false,
            body: message,
            errorText: "",
            bodyLength: computeLength(mapTextToDescendants(message, AppTags, false)),
            mediaUploading: { Name: "", Status: false },
            emoji: "",
            anchorEl: null,
            SelectedScheduleType: this.props.ScheduleType === undefined ? this.props.IsSecureChat ? 1 : 0 : this.props.ScheduleType,
            showScheduleType: this.props.ShowScheduleType ? this.props.ShowScheduleType : false,
            ScheduleDateTime: (this.props.ScheduleDateTime !== -1 && this.props.ScheduleDateTime) ? UtilityService.convertToPreferredTimeZone(this.props.ScheduleDateTime).getTime() : -1,
            ScheduleEndDateTime: (this.props.ScheduleEndDateTime !== -1 && this.props.ScheduleEndDateTime) ? UtilityService.convertToPreferredTimeZone(this.props.ScheduleEndDateTime).getTime() : -1,
            sendingNewMessage: false,
            openTags: false, showTemplates: false, searchInput: '', anchorTemplate: null,
            ShowMoreOptions: false,
            bodySign: this.props.bodySign, defaultSign: "", signLength: this.props.signLength,
            ShowBottomDrawer: false,
            showSign: this.props.showSignature,
            anchorSecureFile: null,
            onEmojiHover: false,
            onFileHove: false,
            onTagsHover: false,
            onTemplateHover: false,
            onSecureFileHover: false,
            onSignatureHover: false,
            showCalnder: false,
            anchorEmjoi: null,
            onScheduleHover: false,
            isDragging: false,
            anchorFaceAuthentication: null,
            onFaceAuthenticationHover: false,
            faceRegistrationInviteLinkStatus: 4,
            sendInviteLoading: false,
            onSecureChatHover: false,
            secureChatPopover: false,
            secureChatAnchor: null,
            characterLimit: 160,
            popoverAnchor: null,
            isGSM: true,
            displayCharacterLimit: 160,

            aiFeaturesPopUp: false,
            falkonAiMessageRefineFeatures: [
                { Name: "Improve", Active: false },
                // { Name: "Fix Spelling & Grammar", Active: false }
            ],
            falkonAiMessageLength: "",
            messageTone: "",
            language: "",
            falkonAiMessage: "",
            aiAnimation: false,
            openTagsInAi: false,
            aiFeaturesAnchor: null,
            originalMessage: "",
            onAiFeaturesHover: false,
            onNotesHover: false,
            internalNoteMode: false,
            files: [],
            sendOptInRequest: false,
            EsignPopover: false,
            onEsignHover: false,
        }
    }

    tagRef = React.createRef<HTMLButtonElement>();
    tagRefInAi = React.createRef<HTMLButtonElement>();
    templateRef = React.createRef<HTMLButtonElement>();
    secureFileRef = React.createRef<HTMLButtonElement>();
    emojiRef = React.createRef<HTMLButtonElement>();
    emojiRefInAi = React.createRef<HTMLButtonElement>();
    faceRef = React.createRef<HTMLButtonElement>();
    calenderRef = React.createRef<HTMLDivElement>();
    SecureChatRef = React.createRef<HTMLDivElement>();
    AiFeaturesRef = React.createRef<HTMLDivElement>();

    ToneOptions = [
        { name: "Formal", icon: <MessageFormalIcon className='w-2 h-2 mr-1' /> },
        { name: "Friendly", icon: <MessageFriendlyIcon className='w-2 h-2 mr-1' /> },
        { name: "Casual", icon: <MessageCasualIcon className='w-2 h-2 mr-1' /> },
        { name: "Playful", icon: <MessagePlayfulIcon className='w-2 h-2 mr-1' /> },
        { name: "Empathetic", icon: <MessageEmpatheticIcon className='w-2 h-2 mr-1' /> }
    ]

    getResolvedTags = () => buildResolvedTags(this.props.customAttributeFields);

    getResolvedAppTags = () => [...ContactTags, ...buildCustomAttributeTags(this.props.customAttributeFields), ...UserTags];

    onClickshowTemplates = (event: any) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    onBodyChange = (event: any) => {
        this.setState({ isTemplate: false });
        this.updateBody(event.target.value.replace(/[\u200B-\u200D\uFEFF]/g, ''));
    };

    onSignatureChange = (event: any, length: number) => {
        this.updateSignature(event.target.value, length)
    };

    updateSignature = (signature: string, length: number) => {
        var text = signature
        var signall = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true"
        this.setState({
            bodySign: text,
            signLength: !!length ? length : this.state.signLength,
            showSign: (!this.state.bodyLength && !length) ? signall : (this.state.bodyLength && !length) ? false : true
        })
    }

    updateCharacterLimit = _.debounce(() => {
        let charLimit = UtilityService.getCharacterLimit(this.state.body, 6, this.state.characterLimit)
        this.setState({ characterLimit: charLimit, isGSM: UtilityService.detectIsGSM(this.state.body) })
        this.displayCharacterLimit(charLimit)
    }, 300);

    displayCharacterLimit = (charLimit) => {
        let limit = (charLimit === 160 || charLimit === 70 || this.getMessageLength() > charLimit) ? charLimit : ((charLimit / 6) * this.getMessageParts(charLimit))
        this.setState({ displayCharacterLimit: limit })
        if (this.props.HandleChange) {
            this.props.HandleChange({
                body: this.getMessageBody(),
                media: this.state.files?.map(x => x.media) || [],
                bodyLength: this.getMessageLength(),
                characterLimit: limit
            });
        }
    }

    updateBody = (message: string) => {
        this.setState({ body: message });
        var text = message;

        var bodyLength = computeLength(mapTextToDescendants(text, this.getResolvedAppTags(), false))
        if (!this.props.IsNewMessage && this.props.PhoneNumbers) {
            setDraftMessage(this.props.PhoneNumbers[0], text)
        }
        this.setState({
            body: text,
            bodyLength,
        });

        if (this.recentTypingEvent === TypeAction.STOP_TYPING && !this.props.IsNewMessage && !this.props.IsAfterHours) {
            MessageService.sendTypingEvent(this.props.PhoneNumbers[0], TypeAction.START_TYPING);
            this.recentTypingEvent = TypeAction.START_TYPING;
        }

        this.updateCharacterLimit()
    }

    handleClick = (event: any) => {
        this.setState({ anchorEl: event.currentTarget })
    };

    handleClose = () => {
        this.setState({ anchorEl: null })
    };

    openTemplates = (event: any) => {
        this.setState({ anchorTemplate: this.templateRef.current })
    };

    onCloseshowTemplates = () => {
        this.setState({ anchorTemplate: null, searchInput: "", onTemplateHover: false });
    };

    searchTemplates = (e: any) => {
        this.setState({ searchInput: e.target.value })
    }

    trimMessage = (message: string, chars: number) => {
        let shortMessage = message.slice(0, chars);
        let index = (shortMessage.lastIndexOf("{{") || shortMessage.lastIndexOf("{") || shortMessage.lastIndexOf("{{_"))
        let indexPosition = (index === 0 || index === -1) ? 0 : index
        let patternFirst = (shortMessage.match(/{{_/g) || []).length
        let patternLast = (shortMessage.match(/_}}/g) || []).length
        let string = shortMessage.slice(0, indexPosition)
        let stringIndex = indexPosition === 0 ? shortMessage : string
        let finalString = patternFirst !== patternLast ? stringIndex : shortMessage;
        return !!message ? finalString + (message.length > chars ? "..." : "") : "";
    }

    handleTemplateClick = async (data: TemplateModel) => {
        this.updateBody(data.Message);
        const updatedFiles = await Promise.all(
            data?.Media?.map(async item => {
                return {
                    file: null,
                    size: 0,
                    media: {
                        ID: item.ID,
                        Name: item.Name,
                        Url: item.Url,
                        ContentType: item?.ContentType?.split('/')[0],
                    } as MediaModel
                };
            })
        );
        this.setState({ files: updatedFiles, isTemplate: true, })
    }

    getMessageBody = () => (!this.props.IsAddTemplate ? this.state.body?.replace(/{{_(DateTime|Date)_}}/g, "") : this.state.body) + (!this.props.IsAddRule && !this.props.IsAddTemplate && this.state.showSign ? '\r\n' + (this.state.bodySign || this.state.defaultSign) : "")
    getMessageBodyWithoutSign = () => this.state.body;
    getMessageLength = () => this.state.bodyLength + (!this.props.IsAddRule && !this.props.IsAddTemplate && this.state.showSign ? this.state.signLength + 1 : 0)
    getMessageParts = (val?: number) => {
        const characterLimit = val ?? this.state.characterLimit;
        if (characterLimit === 160 || characterLimit === 70) {
            return Math.ceil(this.getMessageLength() / characterLimit);
        } else {
            return Math.ceil(this.getMessageLength() / (characterLimit / 6));
        }
    }

    handleMediaChange = async (e: any) => {
        let file = (e?.target?.files[0] || e);
        const files = (e.target?.files || e);
        if (file?.type === "text/plain") {
            setToast(ToasterTexts.Text_File_Not_Supported, ToasterType.DANGER);
            this.closeMedia();
            if (e.target) { e.target.value = "" }
        }
        else {
            if (this.state.files?.length > 7 || files?.length > 8) {
                setToast("Maximum 8 files allowed per message.", ToasterType.DANGER);
                return
            }
            if (files && files?.length > 0) {
                let statefiles = this.state.files;
                let newFiles = []

                if (!this.props.IsAddTemplate && !this.props.IsAddRule) {
                    newFiles = await Promise.all(Array.from(files)?.filter((file: File) => file.type !== "text/plain").map(async (file: File) => ({
                        file,
                        size: file?.size,
                        media: {
                            ID: "",
                            Name: file.name,
                            Url: await this.toBase64(file),
                            ContentType: file.type.split('/')[0]
                        }
                    })));
                }
                else {
                    for (let i = 0; i < files?.length; i++) {
                        const file = files[i]
                        if (file?.type !== "text/plain") {
                            const formData = new FormData();
                            formData.append("file", file);
                            await FileService.UploadNewFile(formData, file?.name, file?.type).then(res => {
                                let result = res.data;
                                newFiles.push({
                                    file: file,
                                    size: file.size,
                                    media: {
                                        ContentType: result.contentType,
                                        ID: result.id,
                                        Name: result.name,
                                        Url: `${Config.API_URL}/api/File/${result.id}/view`
                                    }
                                });
                            })
                        }
                    }
                }

                if (!!this.state.files && this.state.files.some(item => item.size === 0)) {
                    const updatedFiles = await Promise.all(
                        this.state.files.map(async item => {
                            const size = await this.fileSize(item.media.Url);
                            return {
                                file: null,
                                size,
                                media: {
                                    ID: item.media.ID,
                                    Name: item.media.Name,
                                    Url: item.media.Url,
                                    ContentType: item.media.ContentType?.split('/')[0],
                                } as MediaModel
                            };
                        })
                    );
                    statefiles = updatedFiles;
                }
                let mediaSizeLimt = Number(this.props.IsSecureChat ? Config.SECURE_CHAT_FILE_SIZE : this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.Media_Size_Limit)?.Value)
                const savedFiles = [...statefiles, ...newFiles]
                if (savedFiles.reduce((sum, item) => sum + (item.size || 0), 0) > mediaSizeLimt) {
                    setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", this.props.IsSecureChat ? "10" : (mediaSizeLimt / (1024 * 1024))?.toFixed(1)), ToasterType.DANGER);
                    if (e.target) { e.target.value = "" }
                    return;
                }
                if (this.props.IsAddTemplate || this.props.IsAddRule) {
                    if (this.props.HandleChange) {
                        this.props.HandleChange({
                            body: this.getMessageBody(),
                            media: savedFiles.map((x) => x.media) || [],
                            bodyLength: this.getMessageLength()
                        });
                    }
                }
                this.setState({ files: savedFiles });
            }
            if (e.target) { e.target.value = "" }
        }
    };

    fileSize = async (mediaurl: string): Promise<number> => {
        const blob = await FileService.getBlobFromUrl(mediaurl);
        return blob.size;
    }

    toBase64 = (file: any) => new Promise<any>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    closeMedia = (index?: number) => {
        if (this.props.HandleChange) {
            this.props.HandleChange({
                body: this.getMessageBody(),
                media: this.state.files.filter((_, i) => i !== index)?.map(x => x.media) || [],
                bodyLength: this.getMessageLength()
            });
        }
        if (index >= 0) {
            let filterfiles = this.state.files.filter((_, i) => i !== index)
            this.setState({ files: filterfiles });
        }
    }

    getSecureChatMediaComponent = (type: any, file: MediaModel,) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                case MediaType.IMAGE_SVG:
                    return <ImageComponent MediaUrl={file.Url} classname={"w-4 h-4"} text={true} />
                case MediaType.VIDEO:
                    return <Video MediaUrl={file.Url} controls={this.props.IsMobileDevice ? UtilityService.isIPhone(navigator.userAgent) : false} />
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <Audio MediaUrl={file.Url} controls={true} />
                case MediaFileType.PDF:
                    return <PdfIcon />
                case MediaFileType.ZIP:
                    return <ZipIcon />
                case MediaFileType.DOC:
                    return <WordIcon />
                case MediaFileType.DOCX:
                    return <WordIcon />
                case MediaFileType.XLSX:
                    return <XlsIcon />
                case MediaFileType.TXT:
                    return <MediaTxtIcon />
                default:
                    return <MediaDefaultIcon />
            }
        }
    }

    getComponent = (type: string, file?, index?: any) => {
        switch (type) {
            case MediaType.IMAGE:
            case MediaType.IMAGE_GIF:
            case MediaType.IMAGE_JPEG:
            case MediaType.IMAGE_ARW:
            case MediaType.IMAGE_PNG:
            case MediaType.IMAGE_WEBP:
            case MediaType.IMAGE_SVG:
                return <ImageComponent MediaUrl={file.media?.Url} classname="w-5 h-5" text={true} />;

            case MediaType.VIDEO:
            case MediaType.VIDEO_MP4:
                return (<Video MediaUrl={file.media?.Url} controls={this.props.IsMobileDevice ? UtilityService.isIPhone(navigator.userAgent) : false} />);

            case MediaType.AUDIO:
            case MediaType.AUDIO_MP3:
            case MediaType.AUDIO_MPeg:
                return <Audio MediaUrl={file.media?.Url} controls={true} />;

            default:
                return (
                    <File media={{
                        Name: file.media?.Name,
                        ContentType: type,
                        Url: file.media?.Url,
                        ID: file.media?.ID
                    }}
                        onClose={() => this.closeMedia(index)}
                        cross={true}
                    />
                );
        }
    };

    sendMessage = async () => {
        if (this.props.IsSecureChat && (!!this.state.body || !!this.state.files?.length)) {
            const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()
            if (this.state.ScheduleDateTime !== -1 && this.state.SelectedScheduleType !== -1) {

                if (this.state.ScheduleDateTime !== -1 && new Date(this.state.ScheduleDateTime) <= UtilityService.getPreferredTimeZoneTimeNow()) {
                    setToast(ToasterTexts.SCHEDULED_MESSAGE_PASTDATETIME, ToasterType.DANGER);
                    return;
                }
                else {
                    let content = []
                    let mediapayload = []

                    if (!!this.state.files?.length) {
                        mediapayload = await Promise.all(
                            this.state.files.map(async (file) => {
                                let value: string;
                                let type: string;

                                if (!file.file) {
                                    const blob = await FileService.getBlobFromUrl(file.media.Url);
                                    type = blob.type;
                                    const base64String = await this.toBase64(blob);
                                    value = base64String.split(",")[1];
                                } else {
                                    value = (file.media?.Url || "").split(",")[1];
                                    type = (file.file as any).type;
                                }

                                return {
                                    type: type,
                                    file_name: file.media.Name,
                                    value,
                                    payload: {}
                                };
                            })
                        )
                    }

                    if (!!mediapayload?.length) {
                        content = mediapayload
                    }
                    if (this.state.body) {
                        let msgpayload = {
                            type: "text",
                            value: this.getMessageBody(),
                            payload: {}
                        }
                        content = [...content, msgpayload]
                    }

                    if (this.props.ScheduledMessageID && !this.props.IsDuplicate) {

                        const editdata = {
                            content: content,
                            status: 1,
                            schedule_type: this.state.SelectedScheduleType,
                            next_send_time: this.state.ScheduleDateTime,
                            falkon_user_name: Profile.FullName,
                            falkon_user_id: Profile.ID
                        }

                        SecureChatService.updateScheduleMessage(this.props.ScheduledMessageID, editdata).then((res) => {
                            this.setState({ body: "", mediaUploading: { Name: "", Status: false }, showScheduleType: false, files: [] })
                            this.closeMedia();
                            this.props.handleSuccess && this.props.handleSuccess();
                            setToast(res.data.message, ToasterType.SUCCESS)
                        }).catch((err) => {
                            this.setState({ body: "", mediaUploading: { Name: "", Status: false }, showScheduleType: false, files: [] })
                            this.closeMedia();
                            this.props.handleSuccess && this.props.handleSuccess();
                            setToast("Update Schedule Failed", ToasterType.DANGER)
                        })

                    }
                    else {

                        const schedule = {
                            mp_number: this.props.PhoneNumbers[0],
                            content: content,
                            senderId: UserService.getCurrentUserFromLocalStorage().PhoneNumber,
                            status: 1,
                            schedule_type: this.state.SelectedScheduleType,
                            created_at: UtilityService.getPreferredTimeZoneTimeNow().getTime(),
                            next_send_time: this.state.ScheduleDateTime,
                            falkon_user_name: Profile.FullName,
                            falkon_user_id: Profile.ID
                        }

                        SecureChatService.createScheduleMessage(this.props.ParticipantId, schedule).then((res) => {
                            this.ResetDateTime();
                            this.setState({ body: "", mediaUploading: { Name: "", Status: false }, showScheduleType: false, files: [] })
                            this.closeMedia();
                            this.props.handleSuccess && this.props.handleSuccess();
                            setToast(res.data.message, ToasterType.SUCCESS)
                        }).catch((err) => {
                            this.setState({ body: "", mediaUploading: { Name: "", Status: false }, showScheduleType: false, files: [] })
                            this.closeMedia();
                            this.props.handleSuccess && this.props.handleSuccess();
                            setToast("Create Schedule Failed", ToasterType.DANGER)
                        })

                    }
                }
            }
            else {

                if (this.state.body || !!this.state.files?.length) {
                    this.setState({ mediaUploading: { Name: this.state.files[0]?.media?.Name, Status: true } })
                    const msgData = {
                        type: "message",
                        sender_id: UserService.getCurrentUserFromLocalStorage().PhoneNumber,
                        recipient_id: this.props.PhoneNumbers[0],
                        text: this.getMessageBody(),
                        is_inbound: false,
                        falkon_user_name: Profile.FullName,
                        falkon_user_id: Profile.ID,
                        media_payload: await Promise.all(
                            this.state.files.map(async (file) => {
                                let value: string;
                                let type: string;

                                if (!file.file) {
                                    const blob = await FileService.getBlobFromUrl(file.media.Url);
                                    type = blob.type;
                                    const base64String = await this.toBase64(blob);
                                    value = base64String.split(",")[1];
                                } else {
                                    value = (file.media?.Url || "").split(",")[1];
                                    type = (file.file as any).type;
                                }

                                return {
                                    value,
                                    file_name: file.media.Name,
                                    file_type: type,
                                };
                            })
                        )
                    }
                    this.props.FalkonWebSocket.send(JSON.stringify(msgData))
                    this.setState({ body: "" })
                }
            }
        }
        else {
            if ((!this.props.IsNewMessage && this.props.IsUnsubscribe) || this.getMessageParts() > 6) {
                return;
            }

            if (this.state.ScheduleDateTime !== -1 && new Date(this.state.ScheduleDateTime) <= UtilityService.getPreferredTimeZoneTimeNow()) {
                setToast(ToasterTexts.SCHEDULED_MESSAGE_PASTDATETIME, ToasterType.DANGER);
                return;
            }

            if (this.state.ScheduleEndDateTime !== -1 && this.state.ScheduleEndDateTime <= this.state.ScheduleDateTime) {
                setToast(ToasterTexts.SCHEDULED_MESSAGE_END_BEFORE_START, ToasterType.DANGER);
                return;
            }

            if (!this.IsMessageValid()) {
                return;
            }
            if (this.props.IsGroupChat || this.props.GroupChat?.ID) {
                const requiredCredits = this.handleCredits();
                const isNewFlow = this.props.IsNewOrgFlow;
                const remainingCredits = isNewFlow
                    ? this.props.OrgPlanTracker.GroupMsgCredits.RemainingCredits
                    : this.props.PlanMetrics.GroupCreditsUsage.GetRemainingCredits();
                const totalCredits = isNewFlow ? (this.props.OrgPlanTracker.GroupMsgCredits.Total + this.props.OrgPlanTracker.GroupMsgCredits.AddOns) : this.props.PlanMetrics.GroupCreditsUsage.TotalCredits;

                if (remainingCredits >= 0 && remainingCredits < requiredCredits) {
                    setToast(
                        ToasterTexts.GROUPS_CREDIT_ERROR_MESSAGE.replace('<CREDITS>', totalCredits.toString()),
                        ToasterType.DANGER
                    );
                    return;
                }

                this.setState({ sendingNewMessage: true })
                var formData = new FormData();
                let body = this.getMessageBody();
                let Id = uuid()
                let allNumbers = this.props.GroupChat?.PhoneNumbers && this.props.GroupChat?.PhoneNumbers.length > 0 ? this.props.GroupChat?.PhoneNumbers : []
                let numbers = this.props.GroupChat?.PhoneNumbers && this.props.GroupChat?.PhoneNumbers.length > 0 ? this.props.GroupChat?.PhoneNumbers.filter(x => x !== UserService.getUserPhoneNumber()) : []
                if (numbers !== undefined) {
                    if (numbers.length > 0) {
                        for (var i = 0; i < numbers.length; i++)
                            formData.append("Numbers", numbers[i]);
                    }
                }
                formData.append("SequenceId", Id);
                formData.append("Body", body);
                if (this.state.files?.length > 0) {
                    for (const file of this.state.files) {
                        if (file.file) {
                            formData.append("File", file.file);
                        } else if (file.media?.ID) {
                            const blob = await FileService.getBlobFromUrl(file.media.Url);
                            const fileName = file.media.Name;
                            const fileObj = new window.File([blob], fileName, { type: blob.type });
                            formData.append("File", fileObj);
                        }
                    }
                }
                formData.append("Credits", this.getRequiredCredits().toString())

                let groupChatName = this.props.GroupChat?.Name

                if (!this.props.IsNewMessage && this.props.GroupChat?.PhoneNumbers) {
                    let [number] = this.props.GroupChat?.PhoneNumbers.filter(x => x === UserService.getUserPhoneNumber())
                    deleteDraftMessage(number)
                }

                MessageService.sendGroupChatMessage(formData, groupChatName)
                    .then((res) => {
                        this.setState({ body: "", bodySign: "", signLength: this.state.showSign === true ? this.state.signLength : 0, bodyLength: 0, sendingNewMessage: false, showSign: this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true", files: [] });
                        !!this.props.HandleClose && this.props.HandleClose()
                    }).catch((error) => {
                        if (
                            !!error &&
                            !!error.response &&
                            !!error.response.data &&
                            !!error.response.data.message
                        )
                            setToast(error.response.data.message, ToasterType.DANGER, "never")
                        this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, files: [] });
                    });


                if (!this.props.IsNewMessage) {
                    HandlePushConversation(this.props.dispatch,
                        [{
                            SequenceId: Id,
                            Message: body,
                            PhoneNumber: this.props.GroupChat?.ID,
                            GroupChatId: this.props.GroupChat?.ID,
                            IsOutbound: true,
                            DeliveryStatus: DeliveryStatus.SENDING,
                            MessageDateTime: new Date().toISOString(),
                            GroupChat: {
                                ID: this.props.GroupChat?.ID,
                                PhoneNumbers: allNumbers,
                                Name: this.props.GroupChat?.Name,
                            },
                            Media: this.state.files?.length > 0 ? this.state.files.map(x => x.media) : undefined
                        } as ConversationModel],
                    )
                    this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, files: [] });
                    this.closeMedia();
                }
                else {
                    this.setState({ sendingNewMessage: true })
                }
            }
            else {
                if (this.state.ScheduleDateTime !== -1 && this.state.SelectedScheduleType !== -1) {
                    this.setState({ sendingNewMessage: true });
                    let numbers = (this.props.Limit > 1 && this.props.Campaign?.ID) ? this.props.Campaign.ToPhoneNumbers.filter(x => !this.props.GetUnSubscribedContacts.map(y => UtilityService.unmaskPhoneNumber(y.PhoneNumber)).includes(x)) : this.props.PhoneNumbers.filter(x => !this.props.GetUnSubscribedContacts.map(y => UtilityService.unmaskPhoneNumber(y.PhoneNumber)).includes(x)) || [];
                    numbers = numbers.map(x => UtilityService.unmaskPhoneNumberWithPlus(x))
                    numbers = numbers.filter((x, i) => numbers.indexOf(x) === i);

                    const data = this.props.GroupIDs?.length === 1 ? {
                        Groups: this.props.GroupIDs,
                        Body: this.getMessageBody(),
                    } : {
                        Numbers: numbers,
                        Body: this.getMessageBody(),
                        Contacts: this.props.ContactIDs.filter(x => !this.props.GetUnSubscribedContacts.map(y => y.ID).includes(x))
                    };

                    var formData = new FormData();
                    if (data.Groups !== undefined) {
                        if (data.Groups.length > 0) {
                            let groups: any = {};
                            for (var i = 0; i < data.Groups.length; i++) {
                                groups[data.Groups[i]] = "";
                            }
                            Object.keys(groups).forEach(gr => formData.append("Groups", gr));
                        }
                    }
                    if (data.Contacts !== undefined) {
                        if (data.Contacts.length > 0) {
                            for (var i = 0; i < data.Contacts.length; i++)
                                formData.append("Numbers", this.props.Contacts.find(x => x.ID === data.Contacts[i])?.PhoneNumber);
                        }
                    }
                    if (data.Numbers !== undefined) {
                        if (data.Numbers.length > 0 && this.props.Campaign?.ID) {
                            for (var i = 0; i < data.Numbers.length; i++)
                                formData.append("Numbers", data.Numbers[i]);
                        }
                        else if (!this.props.IsNewMessage && data.Contacts.length === 0) {
                            for (var i = 0; i < data.Numbers.length; i++)
                                formData.append("Numbers", data.Numbers[i]);
                        }
                        else if (this.props.IsNewMessage && data.Numbers.length > 0) {
                            for (var i = 0; i < data.Numbers.length; i++)
                                formData.append("Numbers", data.Numbers[i]);
                        }
                    }
                    let body = this.getMessageBody();
                    formData.append("CronExpression", buildCronExpression(this.state.SelectedScheduleType, this.state.ScheduleDateTime));
                    formData.append("ScheduleType", this.state.SelectedScheduleType.toString());
                    if (this.state.ScheduleEndDateTime !== -1) {
                        formData.append("EndDateTime", UtilityService.convertToLocalTimeZone(this.state.ScheduleEndDateTime).toISOString());
                    }
                    formData.append("Body", body);
                    for (let index = 0; index < this.state.files?.length; index++) {
                        const file = this.state.files[index];
                        if (file.file) {
                            formData.append("File", file.file);
                        }
                        else if (!this.props.ScheduledMessageID && !!file.media?.Url) {
                            const blob = await FileService.getBlobFromUrl(file.media.Url);
                            formData.append("File", blob);
                        }
                        else if (file.media?.ID) {
                            formData.append(`Media[${index}].Name`, file.media.Name);
                            formData.append(`Media[${index}].Id`, file.media.ID);
                            formData.append(`Media[${index}].ContentType`, file.media.ContentType);
                        }
                    }

                    formData.append("Credits", this.getRequiredCredits().toString())
                    const campaginName = !!this.props.Campaign && !!this.props.Campaign.Name ? this.props.Campaign.Name : ""
                    const campaginId = !!this.props.Campaign && !!this.props.Campaign.ID ? this.props.Campaign.ID : ""

                    formData.append("CampaignName", campaginName)
                    formData.append("CampaignId", campaginId)
                    if (this.state.ScheduleEndDateTime !== -1) {
                        formData.append("EndDateTime", UtilityService.convertToLocalTimeZone(this.state.ScheduleEndDateTime).toISOString())
                    }
                    if (!this.IsMessageValid()) {
                        return;
                    }
                    if (this.props.ScheduledMessageID) {
                        MessageService.updateScheduleMessage(this.props.ScheduledMessageID, formData)
                            .then((res) => {
                                setToast(ToasterTexts.SCHEDULED_MESSAGE_UPDATED_SUCCESS, ToasterType.SUCCESS)
                                this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, sendingNewMessage: false, files: [] });
                                this.closeMedia();
                                if (this.props.PhoneNumbers) {
                                    deleteDraftMessage(this.props.PhoneNumbers[0]);
                                }
                                this.props.handleSuccess()
                            })
                            .catch((error) => {
                                if (
                                    !!error &&
                                    !!error.response &&
                                    !!error.response.data &&
                                    !!error.response.data.message
                                )
                                    setToast(ToasterTexts.SCHEDULED_MESSAGE_UPDATED_FAILED, ToasterType.DANGER)
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, files: [] });
                                if (this.props.PhoneNumbers) {
                                    deleteDraftMessage(this.props.PhoneNumbers[0]);
                                }
                                setTimeout(() => !!this.props.HandleClose && this.props.HandleClose(), 500);

                            });
                    }
                    else {
                        MessageService.createScheduleMessage(formData)
                            .then((res) => {
                                this.ResetDateTime();
                                { this.props.IsDuplicate ? setToast(ToasterTexts.SCHEDULED_MESSAGE_DUPLICATED_SUCCESS, ToasterType.SUCCESS) : setToast(ToasterTexts.SCHEDULED_MESSAGE_CREATED_SUCCESS, ToasterType.SUCCESS) };
                                !!this.props.handleSuccess ? this.props.handleSuccess() : this.props.IsNewMessage && this.props.HandleClose()
                                this.closeMedia();
                                if (this.props.PhoneNumbers) {
                                    deleteDraftMessage(this.props.PhoneNumbers[0]);
                                }
                                this.setState({
                                    body: "", bodySign: "", signLength: this.state.showSign ? this.state.signLength : 0, bodyLength: 0, sendingNewMessage: false, showScheduleType: false,
                                    showSign: this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true", files: []
                                });
                                if (!this.props.IsNewMessage) {
                                    if (this.props.IsMobileDevice) {
                                        this.CloseBottomDrawer();
                                        this.setState({ showScheduleType: false });
                                        this.ResetDateTime();
                                        this.onCloseshowTemplates();
                                    }
                                    else {
                                        this.ToggleScheduleDatetime();
                                    }
                                }
                            })
                            .catch((error) => {
                                if (
                                    !!error &&
                                    !!error.response &&
                                    !!error.response.data &&
                                    !!error.response.data.message
                                ) { this.props.IsDuplicate ? setToast(ToasterTexts.SCHEDULED_MESSAGE_DUPLICATED_FAILED, ToasterType.DANGER) : setToast(ToasterTexts.SCHEDULED_MESSAGE_CREATED_FAILED, ToasterType.DANGER) };
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, files: [] });
                                if (this.props.PhoneNumbers) {
                                    deleteDraftMessage(this.props.PhoneNumbers[0]);
                                }
                                setTimeout(() => !!this.props.HandleClose && this.props.HandleClose(), 500);
                            });
                    }
                }
                else {
                    if (this.props.IsNewMessage && !this.props.GroupChat?.Name && this.props.Limit > 1) {
                        const requiredCredits = this.handleCredits();
                        const isNewFlow = this.props.IsNewOrgFlow;
                        const remainingCredits = isNewFlow
                            ? this.props.OrgPlanTracker.GroupMsgCredits.RemainingCredits
                            : this.props.PlanMetrics.GroupCreditsUsage.GetRemainingCredits();
                        const totalCredits = isNewFlow
                            ? (this.props.OrgPlanTracker.GroupMsgCredits.Total + this.props.OrgPlanTracker.GroupMsgCredits.AddOns)
                            : this.props.PlanMetrics.GroupCreditsUsage.TotalCredits;

                        if (remainingCredits >= 0 && remainingCredits < requiredCredits) {
                            setToast(ToasterTexts.GROUPS_CREDIT_ERROR_MESSAGE.replace('<CREDITS>', totalCredits.toString()), ToasterType.DANGER);
                            return;
                        }
                        if (!this.IsMessageValid() || (this.props.IsNewMessage && this.state.sendingNewMessage)) {
                            return;
                        }
                        this.setState({ sendingNewMessage: true });

                        let numbers = this.props.PhoneNumbers?.concat(this.props.Contacts.filter(x => this.props.ContactIDs?.includes(x.ID)).map(x => UtilityService.unmaskPhoneNumber(x.PhoneNumber)));
                        numbers = numbers?.filter((x, i) => numbers?.findIndex(y => UtilityService.unmaskPhoneNumber(y) === UtilityService.unmaskPhoneNumber(x)) === i)

                        const data = {
                            Groups: this.props.GroupIDs,
                            Numbers: numbers.filter(x => !this.props.GetUnSubscribedContacts.map(y => UtilityService.unmaskPhoneNumber(y?.PhoneNumber)).includes(x)),
                            Body: this.getMessageBody(),
                        };
                        var formData = new FormData();
                        if (data.Groups !== undefined) {
                            if (data.Groups.length > 0) {
                                let groups: any = {};
                                for (var i = 0; i < data.Groups.length; i++) {
                                    groups[data.Groups[i]] = "";
                                }
                                Object.keys(groups).forEach(gr => formData.append("Groups", gr));
                            }
                        }
                        if (data.Numbers !== undefined) {
                            let Existing = []
                            this.props.Groups?.filter(x => data.Groups.includes(x.ID)).map(x => x.Contacts.filter(x => Existing.push(x.PhoneNumber?.substring(1,))))

                            if (data.Numbers.length > 0) {
                                for (var i = 0; i < data.Numbers.length; i++) {
                                    data.Groups.length > 0 ? !Existing.includes(data.Numbers[i]) && formData.append("Numbers", data.Numbers[i]) : formData.append("Numbers", data.Numbers[i])
                                }
                            }
                        }
                        let body = this.getMessageBody();
                        let Id = uuid()
                        formData.append("SequenceId", Id)
                        formData.append("Body", body);
                        if (this.state.files?.length > 0) {
                            for (const file of this.state.files) {
                                if (file.file) {
                                    formData.append("File", file.file);
                                } else if (file.media?.ID) {
                                    const blob = await FileService.getBlobFromUrl(file.media.Url);
                                    const fileName = file.media.Name;
                                    const fileObj = new window.File([blob], fileName, { type: blob.type });
                                    formData.append("File", fileObj);
                                }
                            }
                        }
                        formData.append("Credits", this.getRequiredCredits().toString())

                        if (!this.props.IsNewMessage && this.props.PhoneNumbers) {
                            deleteDraftMessage(this.props.PhoneNumbers[0])
                        }
                        const campaginName = !!this.props.Campaign && !!this.props.Campaign.Name ? this.props.Campaign.Name : ""
                        const campaginId = !!this.props.Campaign && !!this.props.Campaign.ID ? this.props.Campaign.ID : ""
                        MessageService.sendGroupMessage(formData, campaginName, campaginId)
                            .then((res) => {
                                setToast(ToasterTexts.GROUP_BRODCAST_SENT_SUCCESSFULLY, ToasterType.SUCCESS);
                                this.closeMedia();
                                this.setState({ body: "", bodySign: "", signLength: this.state.showSign === true ? this.state.signLength : 0, bodyLength: 0, sendingNewMessage: false, showSign: this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true", files: [] });

                                !!this.props.HandleClose && this.props.HandleClose(true)
                            })
                            .catch((error) => {
                                if (
                                    !!error &&
                                    !!error.response &&
                                    !!error.response.data &&
                                    !!error.response.data.message
                                )
                                    setToast(error.response.data.message, ToasterType.DANGER, "never")
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, files: [] });
                            });
                        setTimeout(() => !!this.props.HandleClose && this.props.HandleClose(), 500);
                    }
                    else if (!!this.props.Campaign && this.props.Campaign?.ID && !this.props.IsNewMessage) {
                        //check credits available id not throw toaster and return 
                        const requiredCredits = this.handleCredits();
                        const isNewFlow = this.props.IsNewOrgFlow;
                        const remainingCredits = isNewFlow
                            ? this.props.OrgPlanTracker.GroupMsgCredits.RemainingCredits
                            : this.props.PlanMetrics.GroupCreditsUsage.GetRemainingCredits();
                        const totalCredits = isNewFlow
                            ? (this.props.OrgPlanTracker.GroupMsgCredits.Total + this.props.OrgPlanTracker.GroupMsgCredits.AddOns)
                            : this.props.PlanMetrics.GroupCreditsUsage.TotalCredits;

                        if (remainingCredits >= 0 && remainingCredits < requiredCredits) {
                            setToast(
                                ToasterTexts.GROUPS_CREDIT_ERROR_MESSAGE.replace('<CREDITS>', totalCredits.toString()),
                                ToasterType.DANGER
                            );
                            return;
                        }
                        //set loading true 
                        this.setState({ sendingNewMessage: true });
                        //campaign name 
                        const campaginName = !!this.props.Campaign && !!this.props.Campaign.Name ? this.props.Campaign.Name : ""
                        //campaign id
                        const campaginId = !!this.props.Campaign && !!this.props.Campaign.ID ? this.props.Campaign.ID : ""
                        //numbers
                        const data = {
                            Groups: this.props.GroupIDs,
                            Numbers: this.props.Campaign.ToPhoneNumbers.filter(x => !this.props.GetUnSubscribedContacts.map(y => UtilityService.unmaskPhoneNumber(y?.PhoneNumber)).includes(x)),
                            Body: this.getMessageBody(),
                        };
                        var formData = new FormData();

                        if (data.Numbers !== undefined) {
                            if (data.Numbers.length > 0) {
                                for (var i = 0; i < data.Numbers.length; i++) {
                                    formData.append("Numbers", UtilityService.unmaskPhoneNumber(data.Numbers[i]))
                                }
                            }
                        }
                        let body = this.getMessageBody();
                        let Id = uuid()
                        formData.append("SequenceId", Id)
                        formData.append("Body", body);
                        if (this.state.files?.length > 0) {
                            for (const file of this.state.files) {
                                if (file.file) {
                                    formData.append("File", file.file);
                                } else if (file.media?.ID) {
                                    const blob = await FileService.getBlobFromUrl(file.media.Url);
                                    const fileName = file.media.Name;
                                    const fileObj = new window.File([blob], fileName, { type: blob.type });
                                    formData.append("File", fileObj);
                                }
                            }
                        }
                        formData.append("Credits", this.getRequiredCredits().toString())

                        MessageService.sendGroupMessage(formData, campaginName, campaginId)
                            .then((res) => {
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, files: [] });

                                !!this.props.HandleClose && this.props.HandleClose(true)
                            })
                            .catch((error) => {
                                if (
                                    !!error &&
                                    !!error.response &&
                                    !!error.response.data &&
                                    !!error.response.data.message
                                )
                                    setToast(error.response.data.message, ToasterType.DANGER, "never")
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, files: [] });
                            });
                        HandlePushConversation(this.props.dispatch,
                            [{
                                SequenceId: Id,
                                Message: body,
                                PhoneNumber: this.props.Campaign?.ID,
                                IsOutbound: true,
                                DeliveryStatus: DeliveryStatus.SENDING,
                                CampaignId: this.props.Campaign?.ID,
                                GroupChat: null,
                                MessageDateTime: new Date().toISOString(),
                                Campaign: this.props.Campaign,
                                Media: this.state.files?.length > 0 ? this.state.files.map(x => x.media) : undefined
                            } as ConversationModel],
                        )
                        this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0, files: [] });

                        this.closeMedia();
                    }
                    else {
                        if (!this.props.IsNewOrgFlow) {
                            if (this.props.PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && this.props.PlanMetrics.NormalTextingUsage.GetRemainingCredits() < this.handleCredits()) {
                                setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', this.props.PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
                                return;
                            }
                        }
                        if (!this.IsMessageValid() || (this.props.IsNewMessage && this.state.sendingNewMessage)) {
                            return;
                        }
                        this.setState({ sendingNewMessage: true });

                        let number = this.props.PhoneNumbers && this.props.PhoneNumbers?.length === 1 ? this.props.PhoneNumbers[0] : UtilityService.unmaskPhoneNumber(this.props.Contacts.find(x => this.props.ContactIDs?.includes(x.ID))?.PhoneNumber ||
                            UtilityService.unmaskPhoneNumber(this.props.Groups.find(x => this.props?.GroupIDs.includes(x.ID))?.Contacts?.filter(y => !y.IsUnsubscribed)[0]?.PhoneNumber)
                            || "");

                        var formData = new FormData();

                        let body = this.getMessageBody();
                        let Id = uuid();
                        formData.append("SequenceId", Id)
                        formData.append("Body", body);
                        formData.append("ToPhoneNumber", number);
                        if (this.state.files?.length > 0) {
                            for (const file of this.state.files) {
                                if (file.file) {
                                    formData.append("File", file.file);
                                } else if (file.media?.ID) {
                                    const blob = await FileService.getBlobFromUrl(file.media.Url);
                                    const fileName = file.media.Name;
                                    const fileObj = new window.File([blob], fileName, { type: blob.type });
                                    formData.append("File", fileObj);
                                }
                            }
                        }
                        formData.append("Credits", this.getRequiredCredits().toString())
                        if (!this.props.IsNewMessage && this.props.PhoneNumbers) {
                            deleteDraftMessage(this.props.PhoneNumbers[0])
                        }
                        //pushing dummy conversations
                        MessageService.sendNewMessage(formData)
                            .then((res) => {
                                this.closeMedia();
                                !!this.props.HandleClose && this.props.HandleClose(true)
                                this.setState({ aiFeaturesPopUp: false, aiFeaturesAnchor: null, originalMessage: "" })
                            })
                            .catch((error) => {
                                if (
                                    !!error &&
                                    !!error.response &&
                                    !!error.response.data &&
                                    !!error.response.data.message
                                )
                                    setToast(error.response.data.message, ToasterType.DANGER, "default")
                                this.closeMedia();
                                this.setState({ sendingNewMessage: false, body: "", bodySign: "", bodyLength: 0, signLength: 0, aiFeaturesPopUp: false, aiFeaturesAnchor: null, originalMessage: "", files: [] });
                                setTimeout(() => !!this.props.HandleClose && this.props.HandleClose(), 500);
                                CleanConversationHistory(this.props.dispatch, number)
                            });
                        HandlePushConversation(this.props.dispatch,
                            [{
                                SequenceId: Id,
                                Message: body,
                                PhoneNumber: number,
                                IsOutbound: true,
                                GroupChat: null,
                                DeliveryStatus: DeliveryStatus.SENDING,
                                MessageDateTime: new Date().toISOString(),
                                IsOptInCollected: this.props.IsOptInCollected,
                                Media: this.state.files?.length > 0 ? this.state.files.map(x => x.media) : undefined
                            } as ConversationModel],
                        )
                        this.setState({ files: [], body: "", bodySign: "", signLength: this.state.showSign === true ? this.state.signLength : 0, bodyLength: 0, sendingNewMessage: false, showSign: this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true", originalMessage: "" });
                        this.closeMedia();
                    }
                }
            }
        }
    }

    componentDidMount() {
        if (!this.props.SecureFile.length) {
            LoadSecureFiles(this.props.dispatch, { "user_id": UserService.getCurrentUserId() })
        }
        if (!this.props.OptInCollectedMessage && this.props.SignatureSettings?.Settings?.find(
            (s) => s.Code === SettingsService.OptInCollect
        )?.Value === "true") {
            UpdateOptInCollectedMessage(this.props.dispatch)
        }
        if (!this.props.IsAddTemplate && this.props.Templates.length === 0) { LoadTemplates(this.props.dispatch); }
        let Sign = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString();
        let SignALL = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true";
        this.setState({ showSign: SignALL || this.props.showSignature, defaultSign: Sign, signLength: Sign?.length, showScheduleType: this.props.ShowScheduleType ? this.props.ShowScheduleType : false });
        !this.props.IsAfterHours && this.faceRegistrationInvitationStatus();
        if (this.props.MultiMedia && this.props.MultiMedia.length > 0) {
            const updatedFiles = this.props.MultiMedia.map((item) => ({
                file: null,
                size: 0,
                media: {
                    ID: item.ID,
                    Name: item.Name,
                    Url: item.Url,
                    ContentType: item.ContentType?.split('/')[0],
                } as MediaModel
            }));

            this.setState({ files: updatedFiles });
        }
        if (!this.props.IsNewMessage && !this.props.IsSecureChat) {
            const { sendOptInRequest } = this.optinRequestCheck();
            this.setState({ sendOptInRequest });
        }

        if (!this.props.customAttributeFields?.length) {
            LoadCustomAttributeDefinitions(this.props.dispatch);
        }
    }

    componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (prevProps.SuggestionMessage !== this.props.SuggestionMessage) {
            this.setState({ body: this.props.SuggestionMessage, bodyLength: this.props.SuggestionMessage.length })
        }

        if (prevProps.Message !== this.props.Message && this.props.IsAfterHours) {
            const message = this.props.Message ? this.props.Message : ""
            this.setState({ body: message })
        }

        if (this.state.mediaUploading.Status) {
            if (prevProps.History[this.props?.ParticipantId] !== this.props.History[this.props?.ParticipantId]) {
                if (this.props.History[this.props.ParticipantId].find(x => x.Media[0]?.Name === this.state.mediaUploading.Name)) {
                    this.setState({ files: [], mediaUploading: { Name: "", Status: false } })
                }
            }
        }

        if (!this.props.IsMobileDevice && this.props.UnscbscribedConversations?.length !== prevProps.UnscbscribedConversations?.length) {
            CreditsRequried(
                this.props.Limit,
                this.getMessageLength(),
                this.getMessageParts(),
                this.handleCredits(),
                this.props.UnsubscribedCount,
                this.props.BlockedCount,
                !!this.props.GroupChat?.ID || this.props.IsGroupChat ? true : false,
                this.props.IsAddTemplate,
                this.props.IsAddRule
            )
        }
        if (prevProps.ScheduleDateTime !== this.props?.ScheduleDateTime) {
            this.setState({ ScheduleDateTime: !!this.props.ScheduleDateTime ? UtilityService.convertToPreferredTimeZone(this.props?.ScheduleDateTime).getTime() : -1 })
        }
        if (prevProps.ScheduleEndDateTime !== this.props?.ScheduleEndDateTime) {
            this.setState({ ScheduleEndDateTime: !!this.props.ScheduleEndDateTime ? UtilityService.convertToPreferredTimeZone(this.props?.ScheduleEndDateTime).getTime() : -1 })
        }
        if (prevProps.ScheduleType !== this.props?.ScheduleType) {
            this.setState({ SelectedScheduleType: this.props?.ScheduleType != -1 ? this.props?.ScheduleType : this.state.SelectedScheduleType })
        }
        if (JSON.stringify(prevProps.PhoneNumbers) !== JSON.stringify(this.props.PhoneNumbers) && !this.props.IsNewMessage) {
            let draft = this.props.PhoneNumbers ? getDraftMessage(this.props.PhoneNumbers[0] || "") : "";
            let SignALL = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE_TO_ALL_MESSAGES)?.Value?.toString()?.toLowerCase() === "true";
            let Sign = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString();
            this.setState({
                body: draft,
                bodyLength: draft?.length,
                SelectedScheduleType: this.props.IsSecureChat ? 1 : 0,
                showScheduleType: false,
                ScheduleDateTime: -1,
                ScheduleEndDateTime: -1,
                defaultSign: Sign ? Sign : "",
                showSign: (SignALL || this.props.showSignature),
                files: [],
                internalNoteMode: false,
            });
            this.setState({ aiFeaturesPopUp: false, aiFeaturesAnchor: null, originalMessage: "" })
            this.handleResetAiFeatureSelection()
            this.sendStopTypingEvent(prevProps.PhoneNumbers[0])
            if (!this.props.IsNewMessage && !this.props.GroupChat?.ID && !this.props.Campaign?.ID) {
                this.faceRegistrationInvitationStatus();
            }
        }
        if ((prevProps.ContactIDs !== this.props.ContactIDs || prevProps.GroupIDs !== this.props.GroupIDs || prevProps.PhoneNumbers !== this.props.PhoneNumbers) && this.props.IsNewMessage && !this.props.IsAfterHours) {
            this.faceRegistrationInvitationStatus();
        }

        if (JSON.stringify(prevProps.PhoneNumbers) !== JSON.stringify(this.props.PhoneNumbers) ||
            prevProps.ContactIDs !== this.props.ContactIDs ||
            prevProps.PhoneNumbers !== this.props.PhoneNumbers ||
            prevProps.GroupIDs !== this.props.GroupIDs ||
            prevProps.IsNewMessage !== this.props.IsNewMessage
        ) {
            if (!this.props.IsSecureChat) {
                const { sendOptInRequest } = this.optinRequestCheck();
                if (sendOptInRequest !== this.state.sendOptInRequest) {
                    this.setState({ sendOptInRequest });
                }
            }
        }
    }

    handleEmojiSelect = (e: any) => {
        this.setState({
            emoji: e.native
        });
        setTimeout(() => {
            this.setState({ emoji: "" });
        }, 100)
        this.setState({ anchorEmjoi: null })
    };

    openInternalNoteMode = () => {
        this.setState({ internalNoteMode: true });
    };

    closeInternalNoteMode = () => {
        this.setState({ internalNoteMode: false });
    };

    handleCredits = () => {
        if (this.props.GroupChat?.ID) {
            let numbers = this.props.GroupChat?.PhoneNumbers && this.props.GroupChat?.PhoneNumbers.length > 0 ? this.props.GroupChat?.PhoneNumbers.filter(x => x !== UserService.getUserPhoneNumber()) : []
            return this.getRequiredCredits() * numbers?.length
        } else if (this.props.Campaign?.ID) {
            let numbers = this.props.Campaign?.ToPhoneNumbers && this.props.Campaign?.ToPhoneNumbers.length > 0 ? this.props.Campaign?.ToPhoneNumbers.filter(x => x !== UserService.getUserPhoneNumber()).filter(x => !this.props.UnscbscribedConversations?.map(y => y.PhoneNumber).includes(x)) : []
            return numbers?.length * this.getRequiredCredits()
        }
        return this.props.Limit * this.getRequiredCredits()
    }

    getRequiredCredits = () => {
        if (this.props.IsGroupChat && (this.props.GroupChat?.ID || !!this.props.GroupChat?.PhoneNumbers.length)) {
            return this.getMessageParts() * 3 + (!!this.state.files?.length ? 3 : 0)
        }
        return this.getMessageParts() + (!!this.state.files?.length ? 3 : 0)
    }

    sendStopTypingEvent = (phoneNumber: string) => {
        if (this.recentTypingEvent === TypeAction.START_TYPING && !this.props.IsNewMessage) {
            MessageService.sendTypingEvent(phoneNumber, TypeAction.STOP_TYPING);
            this.recentTypingEvent = TypeAction.STOP_TYPING;
        }
    }

    HandleKeyDown = (event: any) => {
        if (this.props.IsSecureChat && !!this.state.body?.trim() && !event?.shiftKey && (event.keyCode === 13 || event.key === "Enter")) {
            this.sendMessage()
            event.preventDefault();
            return
        }
        if (event.ctrlKey && event.keyCode === 13 && !this.state.sendOptInRequest) {
            this.sendMessage()
            this.sendStopTypingEvent(this.props.PhoneNumbers[0]);
            return
        }
        if (event.keyCode === 27) {
            this.closeMedia()
            this.setState({ body: "", bodyLength: 0 });
            this.sendStopTypingEvent(this.props.PhoneNumbers[0]);
            return
        }
        if (!this.props.IsAddRule && !this.props.IsAddTemplate && !this.props.IsAfterHours) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 5000)
        }
    }

    handleScheduleType = (e: any, value: any) => {
        if (value) {
            this.setState({ SelectedScheduleType: value?.Value })
        }
        else {
            this.setState({ SelectedScheduleType: -1, ScheduleDateTime: -1, ScheduleEndDateTime: -1 })
        }
    }

    isOneTimeScheduleType = (scheduleType?: number) => {
        const type = scheduleType ?? this.state.SelectedScheduleType;
        return this.props.IsSecureChat
            ? type === SecureScheduleMessageType.ONE_TIME
            : type === ScheduleMessageType.ONE_TIME;
    }

    ToggleInsertTagPortal = (event: React.MouseEvent<HTMLButtonElement>) => {
        const rect = event.currentTarget.getBoundingClientRect();
        if (!this.state.openTags) {
            this.setState({ popoverAnchor: { top: rect.top, left: rect.left, } })
        }
        else {
            this.setState({ popoverAnchor: null, openTags: false })
        }
        this.setState({ openTags: !this.state.openTags });
    }

    CloseInsertTagPortal = () => {
        this.setState({ openTags: false, openTagsInAi: false });
    }

    ToggleScheduleDatetime = () => {
        if (this.props.IsMobileDevice && !this.props.IsNewMessage) {
            if (this.state.ShowBottomDrawer) {
                this.CloseBottomDrawer();
                this.setState({ showScheduleType: false })
            }
            else {
                this.OpenBottomDrawer();
                this.setState({ showScheduleType: true })
            }
        }
        else {
            if (this.props.HandleScheduleTypeChange) {
                this.props.HandleScheduleTypeChange(!this.state.showScheduleType);
            }
            this.setState({ showScheduleType: !this.state.showScheduleType })
            this.ResetDateTime();
            this.onCloseshowTemplates();
        }
    }

    IsMessageValid = (): boolean => {
        let messageValid = true;
        messageValid = messageValid && !this.props.IsDisabled;
        messageValid = messageValid && !this.props.IsUnsubscribe;
        let body = this.getMessageBodyWithoutSign();
        let tagsToFilterOut = [...ContactTags, ...buildCustomAttributeTags(this.props.customAttributeFields), ...UserTags];

        tagsToFilterOut?.forEach(x => {
            body = body.replaceAll(`{{_${x.id}_}}`, '')
        });

        body = body.trim();

        messageValid = messageValid && (!!body || (!this.state.mediaUploading.Status && !!this.state.files?.length));
        messageValid = messageValid && (this.props.IsSecureChat ? true : this.getMessageParts() <= 6);
        messageValid = messageValid && (!this.state.showScheduleType || (this.state.ScheduleDateTime !== -1 && this.state.SelectedScheduleType !== -1));

        return messageValid;
    }

    onClickSignature = () => {
        let defaultSign = this.props.SignatureSettings?.Settings?.find(x => x.Code === SettingsService.SIGNATURE)?.Value?.toString();
        this.setState({ showSign: !this.state.showSign, defaultSign, bodySign: defaultSign, signLength: defaultSign?.length, openTags: false })
    }

    OpenBottomDrawer = () => {
        this.setState({ ShowBottomDrawer: true })
    }

    CloseBottomDrawer = (success?: boolean) => {
        if (success) {
            this.setState({ body: "", bodySign: "", signLength: 0, bodyLength: 0 });
            this.closeMedia();
        }
        this.setState({ ShowBottomDrawer: false, showScheduleType: false })
    }

    HandleBlur = (event: any) => {
        // event?.preventDefault();
        if (!this.props.IsAddRule && !this.props.IsAddTemplate && !this.props.IsAfterHours) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 1000)
        }
    }

    componentWillUnmount(): void {
        if (!this.props.IsAddRule && !this.props.IsAddTemplate && !this.props.IsAfterHours) {
            debounce(() => this.sendStopTypingEvent(this.props.PhoneNumbers[0]), 500)
        }
    }

    openSecureFile = (event: any) => {
        this.setState({ anchorSecureFile: this.secureFileRef.current })
    }

    closeSecureFile = () => {
        this.setState({ anchorSecureFile: null, onSecureFileHover: false })
    }

    openFaceAuthentication = (event: any) => {
        this.setState({ anchorFaceAuthentication: this.faceRef.current });
        this.setState({ ScheduleDateTime: -1, ScheduleEndDateTime: -1, showScheduleType: false, SelectedScheduleType: 0 })
    }

    closeFaceAuthentication = () => {
        this.resetAllHoverStates()
        this.setState({ anchorFaceAuthentication: null });
        this.setState({ anchorSecureFile: null })
    }

    sendFaceAuthenticationInvite = async () => {
        let invitePhoneNumber = await this.getContatNumber()
        const data = { "organization_id": UserService.getCurrentUserOrgId(), "falkon_user": UserService.getUserPhoneNumber()?.replace("+", ""), "falkon_user_name": UserService?.getCurrentUserFromLocalStorage()?.FullName }

        if (!this.props.IsNewOrgFlow && this.props.PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && this.props.PlanMetrics.NormalTextingUsage.GetRemainingCredits() < 1) {
            setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', this.props.PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
            return;
        }
        this.setState({ sendInviteLoading: true })
        MessageService.sendInvite(data, invitePhoneNumber?.replace("+", "")).then(res => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                const link = res.data.link;
                this.setState({ files: [], body: `Face Registration Link: ${link}` }, () => {
                    this.closeFaceAuthentication()
                    this.sendMessage()
                    this.setState({ faceRegistrationInviteLinkStatus: FaceRegistrationInviteLinkStatus.Pending })
                })
                setToast(ToasterTexts.SEND_INVITE, ToasterType.SUCCESS)
                this.setState({ sendInviteLoading: false })
            }
            else {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
            }
        }).catch(error => {
            setToast(error?.data?.error, ToasterType.DANGER)
            this.setState({ sendInviteLoading: false })
            this.closeFaceAuthentication()
        })
    }

    handleSecureFileClick = (selectedlink) => {
        let data = this.state.body?.length ? " " + selectedlink + " " : selectedlink + " "
        this.updateBody(this.state.body + data);
        this.closeSecureFile()
    }
    getSecureFileName = (filename) => {
        return filename.substring(0, filename.lastIndexOf("."))
    }

    searchSecureFile = (e: any) => {
        this.setState({ searchInput: e.target.value })
    }

    handleSelectChange = (event) => {
        const selectedScheduleType = Number(event.target.value);
        this.setState({
            SelectedScheduleType: selectedScheduleType, ScheduleEndDateTime: this.isOneTimeScheduleType(selectedScheduleType) ? -1 : this.state.ScheduleEndDateTime
        });
    };

    showClander = (isboolen) => {
        this.setState({ showCalnder: isboolen })
    }

    handleCloseSchedule = () => {
        this.setState({ showCalnder: false, ScheduleDateTime: -1, ScheduleEndDateTime: -1 })
    }

    faceRegistrationInvitationStatus = async () => {
        let ContactNumber = await this.getContatNumber();
        let status = !!this.props.FaceAuthenticationFiles?.find(x => x.ContactPhoneNumber === ContactNumber) ? this.props.FaceAuthenticationFiles?.find(x => x.ContactPhoneNumber === ContactNumber)?.Status : FaceRegistrationInviteLinkStatus.NotRegistered
        this.setState({ faceRegistrationInviteLinkStatus: status })
    }

    getContatNumber = () => {
        let invitePhoneNumber = ""
        if (!this.props.IsNewMessage) {
            invitePhoneNumber = this.props.PhoneNumbers[0]
        }
        else {
            invitePhoneNumber = this.props.ContactIDs?.length > 0 ? this.props.Contacts?.find(x => x.ID === this.props.ContactIDs[0])?.PhoneNumber
                : this.props.GroupIDs?.length > 0 ? this.props.Groups?.find(x => x.ID === this.props.GroupIDs[0])?.Contacts?.[0]?.PhoneNumber : this.props.PhoneNumbers?.[0];
        }
        return invitePhoneNumber?.replace("+", "");
    }

    getSelectedContact = () => {
        if (!this.props.IsNewMessage) {
            return !!this.props.Campaign ? this.props.Campaign?.ToPhoneNumbers : !!this.props.GroupChat ? this.props.GroupChat?.PhoneNumbers : this.props.PhoneNumbers
        }
        else {
            let number = !!this.props.PhoneNumbers ? this.props.PhoneNumbers : []
            let contactnumbers = []
            if (!!this.props.ContactIDs) {
                contactnumbers = this.props.Contacts?.filter(x => this.props.ContactIDs.some(y => y === x.ID)).map(x => x.MaskedPhoneNumber?.replace("+", ""))
            }
            let groupContacts = []
            if (this.props.GroupIDs) {
                groupContacts = this.props.Groups.filter(x => this.props.GroupIDs?.some(y => y === x.ID)).flatMap(x => x.Contacts).map(x => x.PhoneNumber?.replace("+", ""))
            }
            return [...number, ...contactnumbers, ...groupContacts].filter((value, index, self) => self.indexOf(value) === index)
        }
    }

    handleEsignPopOver = () => {
        if (this.state.EsignPopover) {
            this.setState({ EsignPopover: false })
        }
        else {
            this.setState({ EsignPopover: true })
            this.setState({ ScheduleDateTime: -1, ScheduleEndDateTime: -1, showScheduleType: false, SelectedScheduleType: 0 })
        }
    }

    handleSecureChatPopOver = () => {
        if (this.state.secureChatPopover) {
            this.setState({ secureChatPopover: false, secureChatAnchor: null })
        }
        else {
            this.setState({ secureChatPopover: true, secureChatAnchor: this.SecureChatRef.current })
            this.setState({ ScheduleDateTime: -1, ScheduleEndDateTime: -1, showScheduleType: false, SelectedScheduleType: 0 })
        }
    }

    handleSecureChatInviteLink = async () => {
        let invitePhoneNumber = await this.getContatNumber()
        if (!this.props.IsNewOrgFlow && this.props.PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && this.props.PlanMetrics.NormalTextingUsage.GetRemainingCredits() < 1) {
            setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', this.props.PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
            return;
        }
        this.setState({ sendInviteLoading: true })
        SecureChatService.genearateSecureChatLink(invitePhoneNumber?.replace("+", ""), { organization_id: UserService.getCurrentUserFromLocalStorage().OrgId, organization_name: UserService.getCurrentUserFromLocalStorage().OrganizationName, falkon_user_number: UserService.getCurrentUserFromLocalStorage().PhoneNumber })
            .then((res) => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    this.setState({ secureChatPopover: false, files: [], body: `${UserService.getCurrentUserFromLocalStorage().FirstName}(${this.props.OrganizationName}) has sent you a secure link to chat,please click on the link to initiate conversation ${res.data.link}` }, () => { this.sendMessage() })
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
                this.setState({ sendInviteLoading: false })
            }).catch((err) => {
                this.setState({ sendInviteLoading: false })
            })
    }


    handleMessageRefineFeatures = (name) => {
        this.setState({ falkonAiMessageRefineFeatures: this.state.falkonAiMessageRefineFeatures.map(x => x.Name === name ? { ...x, Active: !x.Active } : x) })
    }

    handleMessageLengthFeatures = (length) => {
        this.setState({ falkonAiMessageLength: length })
    }

    handleResetAiFeatureSelection = () => {
        this.setState({
            falkonAiMessageRefineFeatures: [
                { Name: "Improve", Active: false },
            ],
            falkonAiMessageLength: "",
            messageTone: "", language: "",
        })
    }

    handleAIfeaturesPopOver = () => {
        if (this.state.aiFeaturesPopUp) {
            this.setState({ aiFeaturesPopUp: false, aiFeaturesAnchor: null, originalMessage: "" })
            this.handleResetAiFeatureSelection()
        }
        else {
            this.setState({ aiFeaturesPopUp: true, aiFeaturesAnchor: this.AiFeaturesRef.current })
        }
    }

    handleMessageImprovement = () => {
        this.setState({ aiAnimation: true })
        FalkonAiService.getImprovedMessage({
            message: this.state.body,
            length: this.state.falkonAiMessageLength,
            improve: this.state.falkonAiMessageRefineFeatures[0].Active,
            tone: this.state.messageTone,
            translate: this.state.language,
            channel: 6
        }).then((res) => {
            this.setState({ originalMessage: this.state.body, body: res.data.refined_message, bodyLength: res.data.refined_message.length, aiAnimation: false })
            this.handleResetAiFeatureSelection();
        }).catch(() => {
            this.setState({ aiAnimation: false })
            this.handleAIfeaturesPopOver();
        })
    }

    resetToOriginalMessage = () => {
        this.setState({ body: this.state.originalMessage, bodyLength: this.state.originalMessage.length, originalMessage: "" })
    }

    resetAllHoverStates = (exceptState = null) => {
        const hoverStates = {
            onEmojiHover: false,
            onTagsHover: false,
            onSecureFileHover: false,
            onFileHove: false,
            onTemplateHover: false,
            onSignatureHover: false,
            onScheduleHover: false,
            onFaceAuthenticationHover: false,
            onSecureChatHover: false,
            onAiFeaturesHover: false,
            onNotesHover: false,
        };
        if (exceptState) {
            hoverStates[exceptState] = true;
        }
        this.setState(hoverStates);
    }

    debouncedHoverReset = (hoverState = null) => {
        debounce(() => {
            this.resetAllHoverStates(hoverState);
        }, 50);
    }
    CustomPopper = (props) => {
        return <Popper {...props} placement="top" className='w-auto max-w-20 min-w-10' style={{ zIndex: 100000 }} />;
    };

    optinRequestCheck = (): { sendOptInRequest: boolean } => {
        let sendOptInRequest = false;

        const isOptInCollectEnabled = this.props.SignatureSettings?.Settings?.find(
            (s) => s.Code === SettingsService.OptInCollect
        )?.Value === "true";
        if (
            isOptInCollectEnabled &&
            !this.props.Campaign?.ID &&
            this.props.Limit === 1 &&
            !this.props.GroupChat?.ID &&
            !this.props?.IsGroupChat &&
            (this.props.ContactIDs?.length + this.props.PhoneNumbers?.length + this.props.GroupIDs?.length) > 0
        ) {
            if (this.props.IsNewMessage) {
                let groupinContact = []
                if (this.props.GroupIDs?.length) {
                    groupinContact = [UtilityService.unmaskPhoneNumber(this.props.Groups.find(x => this.props?.GroupIDs.includes(x.ID))?.Contacts?.filter(y => !y.IsUnsubscribed)[0]?.PhoneNumber)]
                }
                const savedNumbers = [
                    ...this.props.Contacts.filter((c) => this.props.ContactIDs.includes(c.ID)).map((c) => c.PhoneNumber),
                    ...this.props.PhoneNumbers,
                    ...groupinContact
                ].filter((num, index, arr) => arr.indexOf(num) === index);

                const unsubscribedSet = new Set(
                    this.props.GetUnSubscribedContacts.map((c) => c.PhoneNumber?.replace("+", ""))
                );

                const numbers = savedNumbers.filter(
                    (num) => !unsubscribedSet.has(num.replace("+", ""))
                );

                if (numbers.length === 1) {
                    const conversation = this.props.Conversations.find(
                        (c) => c.PhoneNumber?.replace("+", "") === numbers[0]
                    );

                    const contact = !conversation && this.props.Contacts.find(x => x.PhoneNumber === numbers[0])
                    if (!!conversation && !conversation?.IsOptInCollected) {
                        sendOptInRequest = true;
                    }
                    else if (!!contact && !contact.IsOptInCollected) {
                        sendOptInRequest = true;
                    } else {
                        sendOptInRequest = false;
                    }
                } else {
                    sendOptInRequest = false;
                }
            } else {
                sendOptInRequest = !this.props.IsOptInCollected;
            }
        }

        return { sendOptInRequest };
    };

    render() {
        let regex = /(?:\{{_)\w+(?=\_}})/g
        const templates = this.props.Templates.filter((x) => (this.props.IsSecureChat || this.props.IsGroupChat || this.props.GroupChat?.ID) ? !regex.test(x.Message) : true)
        const filteredTemplates = (templates
            .filter((x) =>
                this.state.searchInput
                    ? (x.Title || "")
                        .toLowerCase()
                        .includes(this.state.searchInput.toLowerCase()) ||
                    (x.Message || "")
                        .toLowerCase()
                        .includes(this.state.searchInput.toLowerCase())
                    : (this.props.IsSecureChat || this.props.IsGroupChat || this.props.GroupChat?.ID) ? !regex.test(x.Message) : true)).filter((x) => (this.props.IsSecureChat || this.props.IsGroupChat || this.props.GroupChat?.ID) ? !regex.test(x.Message) : true)

        return (
            <div className={`d-flex flex-direction ${this.props.IsMobileDevice ? `pt-1 ${this.props.isDarkMode ? "" : "bg-color-secondary"} ` : ""} ${this.props.className} ${(this.props.IsNewMessage || this.props.IsAddRule || this.props.IsAddTemplate) ? "w-fill" : "mt-1"}`}
                onDrop={(event) => {
                    event.preventDefault()
                    this.setState({ isDragging: false });
                    if (this.props.SignatureSettings?.Settings.find(x => x?.Code === "MMSF")?.Value === "True") {
                        const files = Array.from(event.dataTransfer.items).map((item) => item.getAsFile() as File)
                        if (files !== null) {
                            this.handleMediaChange(files)
                        }
                    }
                }}
                onDragOverCapture={(event) => {
                    event.preventDefault();
                    this.setState({ isDragging: true });
                }}

                onDragLeave={(event) => {
                    this.setState({ isDragging: false });
                }}

                onPaste={(event) => {
                    const files = Array.from(event.clipboardData.items).filter((item) => item.kind === "file")
                        .map((item) => item.getAsFile() as File)
                        .filter((file): file is File => file !== null);
                    if (files.length > 0) {
                        this.handleMediaChange(files)
                    };
                }}
            >
                {
                    this.state.sendOptInRequest && <div className={`d-flex justify-between align-center mx-auto w-p-95  RichEditor-root-border br-2  ${this.props.IsMobileDevice ? "flex-direction " : ""} ${this.props.IsNewMessage ? "color-primary-danger" : "b-around-consent-message-border color-button-text bg-color-consent-message-bg"} px-1 mb-1`}>
                        <div className={` h4-regular ${this.props.IsMobileDevice ? "" : "mr-2"}`}>This contact hasn’t opted in yet. You can only send an opt-in request.
                        </div>
                        <ButtonComponent ButtonLabel={'Request Opt-In'} Variant={'primary-btn'} OnClick={() => { this.setState({ body: this.props.OptInCollectedMessage }, () => { this.sendMessage() }) }} />
                    </div>
                }
                {
                    this.props.SignatureSettings?.Settings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() === "true" &&
                    this.state.aiFeaturesPopUp && <div className={`h-6 mx-auto suggested-reply-box ${this.props.isDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"} ${this.props.IsMobileDevice ? "br-5" : "br-3"} mb-1 bg-color-secondary`} style={{ bottom: this.AiFeaturesRef.current.getBoundingClientRect().bottom + 52, left: this.AiFeaturesRef.current.getBoundingClientRect().left, right: this.AiFeaturesRef.current.getBoundingClientRect().right, top: this.AiFeaturesRef.current.getBoundingClientRect().top - 52, width: this.AiFeaturesRef.current.getBoundingClientRect().width }}>
                        <div className='d-flex align-center w-p-100 h-p-100'>
                            <div className={`br-4 ${!this.props.IsMobileDevice ? this.props.isDarkMode ? "ai-chip px-2 h5-medium ml-2" : "ai-features-select-box px-2 h5-medium ml-2" : "mx-1 px-1 h5"} align-center justify-center d-flex min-h-4 c-pointer ${this.state.falkonAiMessageRefineFeatures[0].Active ? this.props.isDarkMode && !this.props.IsMobileDevice ? " ai-chip" : "bg-color-ai-primary-btn-box-shadow color-ai-primary-btn" : "color-text-field-font"}`} onClick={() => this.setState({ falkonAiMessageRefineFeatures: [{ Name: "Improve", Active: !this.state.falkonAiMessageRefineFeatures[0].Active }] })}>
                                {this.props.IsMobileDevice ? <MessageImprovePurpleIcon className='mr-1' /> : this.props.isDarkMode && this.state.falkonAiMessageRefineFeatures[0].Active ? <MessageImproveIcon className='mr-1' style={{ color: "#caa1ff" }} /> : <MessageImproveIcon className='mr-1' />} Improve
                            </div>
                            <Autocomplete
                                className={`${this.props.IsMobileDevice ? "mr-1" : "min-w-20 ml-1"} br-4 b-none`}
                                value={this.state.messageTone}
                                disableClearable
                                onChange={(event, value) => this.setState({ messageTone: value })}
                                options={["Formal", "Friendly", "Casual", "Playful", "Empathetic"]}
                                getOptionLabel={(option) => option}
                                classes={{
                                    input: `${this.props.isDarkMode ? "" : "color-text-field-font"} ${this.props.IsMobileDevice ? "h5 w-p-40" : "h5-medium"} max-h-4 py-0 c-pointer`
                                }}
                                PopperComponent={this.props.IsMobileDevice ? this.CustomPopper : undefined}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <div className={`${this.props.IsMobileDevice ? "h5" : "h5-medium"} d-flex align-center`}>
                                            {this.ToneOptions.find(x => x.name === option).icon} {option}
                                        </div>
                                    </li>
                                )}
                                renderInput={(params) =>
                                    <TextField
                                        className=''
                                        {...params}
                                        placeholder="tone"
                                        required
                                        variant="standard"
                                        size='small'
                                        onKeyDown={(e) => e.preventDefault()}
                                        inputProps={{ ...params.inputProps, readOnly: true }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {this.props.IsMobileDevice ? <MessageTonePurpleIcon /> : this.state.messageTone !== "" && this.props.isDarkMode ? <MessageToneIcon className='color-purple-icon' /> : <MessageToneIcon />}
                                                </InputAdornment>
                                            ),
                                            className: `${params.InputProps.className} br-4 ${this.props.IsMobileDevice ? "px-0" : this.props.isDarkMode ? 'ai-chip px-2' : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                                        }}
                                    />}
                            />
                            <Autocomplete
                                className={`${this.props.IsMobileDevice ? "mr-1" : "min-w-16 ml-1"} br-4 b-none`}
                                value={this.state.falkonAiMessageLength}
                                disableClearable
                                onChange={(e, value) => this.handleMessageLengthFeatures(value)}
                                options={["Shorten", "Expand"]}
                                getOptionLabel={(option) => option}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <div className={`${this.props.IsMobileDevice ? "h5" : "h5-medium"} d-flex align-center`}>
                                            {option}
                                        </div>
                                    </li>
                                )}
                                classes={{
                                    input: `${this.props.isDarkMode ? "" : "color-text-field-font"} ${this.props.IsMobileDevice ? "h5 w-p-40" : "h5-medium"} max-h-4 py-0 c-pointer`
                                }}
                                PopperComponent={this.props.IsMobileDevice ? this.CustomPopper : undefined}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        placeholder="length"
                                        required
                                        variant="standard"
                                        size='small'
                                        onKeyDown={(e) => e.preventDefault()}
                                        inputProps={{ ...params.inputProps, readOnly: true }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {this.props.IsMobileDevice ? <MessageLengthPurpleIcon /> : this.state.falkonAiMessageLength !== "" && this.props.isDarkMode ? <MessageLengthIon style={{ color: "#caa1ff" }} /> : <MessageLengthIon />}
                                                </InputAdornment>
                                            ),
                                            className: `${params.InputProps.className} br-4 ${this.props.IsMobileDevice ? "px-0" : this.props.isDarkMode ? "ai-chip px-2" : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                                        }}
                                    />}
                            />
                            <Autocomplete
                                className={`${this.props.IsMobileDevice ? "" : "min-w-16 ml-1"} br-4 b-none`}
                                value={this.state.language}
                                disableClearable
                                onChange={(event, value) => this.setState({ language: value })}
                                options={["Spanish", "French", "English"]}
                                getOptionLabel={(option) => option}
                                renderOption={(props, option) => (
                                    <li {...props}>
                                        <div className={`${this.props.IsMobileDevice ? "h5" : "h5-medium"} d-flex align-center`}>
                                            {option}
                                        </div>
                                    </li>
                                )}
                                classes={{
                                    input: ` ${this.props.isDarkMode ? "" : "color-text-field-font"}  ${this.props.IsMobileDevice ? "h5 w-p-50" : "h5-medium"} max-h-4 py-0 c-pointer`
                                }}
                                PopperComponent={this.props.IsMobileDevice ? this.CustomPopper : undefined}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        placeholder="translate"
                                        variant="standard"
                                        required
                                        onKeyDown={(e) => e.preventDefault()}
                                        inputProps={{ ...params.inputProps, readOnly: true }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {this.props.IsMobileDevice ? <MessageTranslatePurpleIcon /> : this.state.language !== "" && this.props.isDarkMode ? <MessageTranslateIcon style={{ color: "#caa1ff" }} /> : <MessageTranslateIcon />}
                                                </InputAdornment>
                                            ),
                                            className: `${params.InputProps.className} br-4 ${this.props.IsMobileDevice ? "px-0" : this.props.isDarkMode ? "ai-chip px-2" : "ai-features-select-box px-2"} align-center justify-center d-flex min-h-4`,
                                        }}
                                    />}
                            />
                            {this.state.aiAnimation ?
                                <AnimateLoaderComponent LoaderAnimation={falkonAiMessageGeneratingLoader} className={`${this.props.IsMobileDevice ? "max-w-7 d-flex align-center justify-center ml-auto" : "w-10 h-10 mt-4"}`} />
                                :
                                (this.state.bodyLength && (this.state.falkonAiMessageRefineFeatures.find(x => x.Active) || !!this.state.falkonAiMessageLength.length || !!this.state.language.length || !!this.state.messageTone.length))
                                    ?
                                    <RefineMessageActiveButtonicon className={`${this.props.IsMobileDevice ? "min-w-4 ml-auto mr-1" : "mx-2 min-w-4 c-pointer"}`} onClick={this.handleMessageImprovement} />
                                    :
                                    <RefineMessageDisableButtonicon className={`${this.props.IsMobileDevice ? "min-w-4 ml-auto mr-1" : "mx-2 min-w-4"}`} />

                            }
                            {!this.props.IsMobileDevice &&
                                <div className='ml-auto d-flex align-center'>
                                    {!!this.state.originalMessage.length &&
                                        <Tooltip title='Undo Message' placement='top' className=''>
                                            <RefineMessageUndoicon className='mr-1 c-pointer' onClick={this.resetToOriginalMessage} />
                                        </Tooltip>
                                    }
                                    {this.props.isDarkMode ? <AICancelIcon className='mr-1 c-pointer' onClick={() => { this.handleAIfeaturesPopOver(); }} /> : <SuggestedRepliesBoxCancelIcon className='mr-1 c-pointer' onClick={() => { this.handleAIfeaturesPopOver(); }} />}
                                </div>
                            }
                        </div>
                        {this.props.IsMobileDevice &&
                            <div className='d-flex align-center p-relative justify-flex-end ml-auto w-20' style={{ bottom: 80, right: 0 }}>
                                {!!this.state.originalMessage.length &&
                                    <Tooltip title='Undo Message' placement='top' className=''>
                                        <RefineMessageUndoicon className='c-pointer' onClick={this.resetToOriginalMessage} />
                                    </Tooltip>
                                }
                                <SuggestedRepliesBoxCancelIcon className='c-pointer' onClick={() => { this.handleAIfeaturesPopOver(); }} />
                            </div>
                        }
                    </div>
                }

                {this.state.internalNoteMode ? (
                    <InternalNoteComposer
                        composerWrapRef={this.AiFeaturesRef}
                        IsMobileDevice={this.props.IsMobileDevice}
                        IsNewMessage={this.props.IsNewMessage}
                        IsSecureChat={this.props.IsSecureChat}
                        IsAfterHours={this.props.IsAfterHours}
                        IsAfterHoursActive={this.props.IsAfterHoursActive}
                        isDarkMode={this.props.isDarkMode}
                        Users={this.props.Users}
                        PhoneNumbers={this.props.PhoneNumbers}
                        ContactIDs={this.props.ContactIDs}
                        Contacts={this.props.Contacts}
                        hasEmojis={this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasEmojis : this.props.PlanMetrics.HasAccessToEmojis}
                        onClose={this.closeInternalNoteMode}
                    />
                ) : (
                    <div ref={this.AiFeaturesRef} className={`d-flex ${(this.props.isDarkMode && !this.props.IsNewMessage && !this.props.IsAddTemplate && !this.props.IsAddRule) ? "bg-color-composer-bg" : ""} ${this.props.IsNewMessage ? this.props.IsMobileDevice ? "flex-column-reverse" : "flex-column-reverse mx-1 br-5" : this.props.IsMobileDevice ? "flex-direction bg-color-nav-bar-mobile" : `flex-direction RichEditor-root-border ${!this.props.IsAfterHours ? "mx-2" : ''} br-5`} ${this.props.IsAfterHoursActive ? 'disabled bg-color-settings-background' : ""}`}>
                        <Fragment>
                            <div className={`${(this.props.IsMobileDevice && !this.props.IsNewMessage) ? "mx-1" : ""}`}>
                                <div className='d-flex justify-between h-6 align-center' onMouseLeave={() => { this.debouncedHoverReset() }}>
                                    <div className='d-flex align-center'>
                                        {(this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasEmojis : this.props.PlanMetrics.HasAccessToEmojis) &&
                                            <CustomTooltip title='Emoji' placement='bottom'>
                                                <div className="my-auto">
                                                    <button tabIndex={13} data-up-arrow-index={300} ref={this.emojiRef}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (this.state.anchorEmjoi) {
                                                                this.setState({ anchorEmjoi: null })

                                                            } else {
                                                                this.setState({ anchorEmjoi: this.emojiRef.current })
                                                            }
                                                        }}
                                                        onMouseEnter={() => { this.setState({ onEmojiHover: true }) }}
                                                        onMouseLeave={() => { this.setState({ onEmojiHover: false }) }}
                                                    >
                                                        {(this.state.onEmojiHover || !!this.state.anchorEmjoi) ? <EmojiActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerSmileIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                        }
                                                    </button>
                                                </div>
                                            </CustomTooltip >}
                                        {(this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasMMSEnabled : this.props.PlanMetrics.HasAccessToMMS) && !this.props.IsAfterHours && !this.state.mediaUploading.Status && < CustomTooltip title='Attach File' placement='bottom'>
                                            <div className="my-auto">
                                                <label onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget?.click() } }} role="button" data-up-arrow-index={300} tabIndex={14} onClick={this.handleClick} className={``} style={this.state.showScheduleType ? { marginBlock: "auto" } : {}} htmlFor={"Upload" + this.props.UniqId}
                                                    onMouseEnter={() => { this.debouncedHoverReset("onFileHove") }}
                                                    onMouseLeave={() => { this.debouncedHoverReset() }}
                                                >
                                                    {this.state.onFileHove ? <FileActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerAttachmentIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />}
                                                </label>
                                                <input className={"d-none"} id={"Upload" + this.props.UniqId} onChange={this.handleMediaChange}
                                                    accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.xlsx,.zip,.txt" multiple type="file" />
                                            </div></CustomTooltip>}
                                        {
                                            !!this.props.GroupChat?.ID || this.props.IsGroupChat ? null : !this.props.IsSecureChat && (this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasCustomTags : true) &&
                                                <Tooltip title='Insert Tag' placement='bottom' className='mt-1'>
                                                    <div className="my-auto">
                                                        <button tabIndex={15} ref={this.tagRef} data-up-arrow-index={300} onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.ToggleInsertTagPortal(e) }}
                                                            onMouseEnter={() => { this.debouncedHoverReset("onTagsHover") }}
                                                            onMouseLeave={() => { this.debouncedHoverReset() }}
                                                        >
                                                            {(this.state.onTagsHover || this.state.openTags) ? <TagsActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerTagsIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                            }
                                                        </button>
                                                    </div>
                                                </Tooltip>
                                        }
                                        {
                                            !this.props.IsAddTemplate &&
                                            (this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasTemplates : true) &&
                                            <CustomTooltip title='Templates' placement='bottom'>
                                                <div className="my-auto">
                                                    <button ref={this.templateRef} tabIndex={15} data-up-arrow-index={300} onClick={(e) => {
                                                        e.preventDefault()
                                                        if (Boolean(this.state.anchorTemplate)) {
                                                            this.onCloseshowTemplates()
                                                        } else {
                                                            this.openTemplates(e)
                                                        }
                                                    }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onTemplateHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {(this.state.onTemplateHover || !!this.state.anchorTemplate) ? <TemplateActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerTemplateIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                        }
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {
                                            !this.props.IsAddRule && !this.props.IsAddTemplate && (this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasSignature : true) &&
                                            < CustomTooltip title='Signature' placement='bottom'>
                                                <div className="my-auto">
                                                    <button tabIndex={15} data-up-arrow-index={300} onClick={(e) => this.onClickSignature()}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onSignatureHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {(this.state.onSignatureHover || this.state.showSign) ? <SignatureActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerSignatureIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                        }
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {
                                            (this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasAccessToSecureFiles : this.props.PlanMetrics.HasAccessToSecureFiles) && !this.props.IsSecureChat && !this.props.IsAfterHours && !this.state.sendOptInRequest && <CustomTooltip title='Secure Files' placement='bottom'>
                                                <div className="my-auto">
                                                    <button ref={this.secureFileRef} tabIndex={15} data-up-arrow-index={300}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            if (Boolean(this.state.anchorSecureFile)) {
                                                                this.closeSecureFile()
                                                            } else {
                                                                this.openSecureFile(e)
                                                            }
                                                        }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onSecureFileHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {(this.state.onSecureFileHover || !!this.state.anchorSecureFile) ? <LinkActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <LinkDiableIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />}
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {(this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasAccessToSecureChat : this.props.PlanMetrics.HasAccessToSecureChat) && this.props.Limit === 1 && !this.props.IsSecureChat && !this.props.IsAddRule && !this.props.IsAddTemplate && !this.props.IsAfterHours && !this.state.sendOptInRequest &&
                                            <CustomTooltip title='Secure Chat' placement='bottom'>
                                                <div className="my-auto" ref={this.SecureChatRef}>
                                                    <button tabIndex={15} data-up-arrow-index={300} onClick={(e) => { this.handleSecureChatPopOver() }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onSecureChatHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {
                                                            (this.state.onSecureChatHover || this.state.secureChatPopover) ? <SecureChatActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <SecureChatInviteGreyIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                        }
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {(this.props.Limit === 1 && !this.props.IsSecureChat && !this.state.showScheduleType && !this.props.IsAddRule && !this.props.IsAddTemplate && !this.props.IsAfterHours && !this.state.sendOptInRequest) &&
                                            <CustomTooltip title='Send Doc for Signature' placement='bottom'>
                                                <div className="my-auto" ref={this.SecureChatRef}>
                                                    <button onClick={(e) => { this.handleEsignPopOver() }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onEsignHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {
                                                            (this.state.onEsignHover || this.state.EsignPopover) ? <ComposerEsignTemplateIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerEsignTemplateIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />
                                                        }
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {
                                            this.state.EsignPopover &&
                                            <Dialog
                                                open={this.state.EsignPopover}
                                                onClose={() => { this.setState({ EsignPopover: false }) }}
                                                classes={{ paper: `br-4 ${this.props.IsMobileDevice ? "w-p-95" : "w-p-80"} h-p-80 box-shadow-primary-header-shadow ${this.props.isDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"} d-flex justify-center align-center m-auto` }}
                                            >
                                                <DialogContent className="w-p-100 p-0">
                                                    <FalkonesignPopOverComponent PhoneNumber={this.props.PhoneNumbers[0]} HandleClose={() => { this.setState({ EsignPopover: false }) }} />
                                                </DialogContent>
                                            </Dialog>
                                        }
                                        {
                                            this.state.secureChatPopover &&
                                            <Popover
                                                open={this.state.secureChatPopover}
                                                onClose={() => { this.setState({ secureChatPopover: false }) }}
                                                classes={{ paper: `br-2 w-26 box-shadow-primary-header-shadow ${this.props.isDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"} p-2 d-flex justify-center align-center` }}
                                                anchorEl={this.state.secureChatAnchor}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'center',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'center',
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={() => { this.setState({ secureChatPopover: false, onSecureChatHover: false }) }}>
                                                    <DialogContent className="p-2">
                                                        <div className='mx-auto h5-semibold d-flex justify-center align-center'>Send a secure chat invite</div>
                                                        <div className='mx-auto d-flex justify-center'>
                                                            <SecureChatInviteActiveIcon className='w-8 h-8 pt-1' />
                                                        </div>
                                                        <ButtonComponent Loading={this.state.sendInviteLoading} ButtonLabel={'send invite'} Variant={"primary-btn"} ClassName='mx-auto' OnClick={this.handleSecureChatInviteLink} />
                                                    </DialogContent>
                                                </ClickAwayListener>
                                            </Popover>
                                        }
                                        {
                                            this.state.anchorSecureFile &&
                                            <Popover
                                                open={Boolean(this.state.anchorSecureFile)}
                                                anchorEl={this.state.anchorSecureFile}
                                                onClose={() => this.closeSecureFile()}
                                                classes={{ paper: `br-3  w-75 ${this.props.isDarkMode ? "bg-color-sidebar-bg" : ""}  ${this.props.IsMobileDevice ? "" : "p-1 px-2"}` }}
                                                anchorOrigin={this.props.IsMobileDevice ? { vertical: 'top', horizontal: 'center' } : { vertical: 'top', horizontal: 'center' }}
                                                transformOrigin={this.props.IsMobileDevice ? { vertical: 'bottom', horizontal: 'center' } : { vertical: 'bottom', horizontal: 'center' }}
                                            >
                                                <ClickAwayListener onClickAway={() => this.closeSecureFile()}>
                                                    <SecureFilePopoverComponent
                                                        CloseSecurefilePopover={(url) => {
                                                            if (!!url) {
                                                                this.setState({ body: this.state.body + " " + url })
                                                            }
                                                            this.closeSecureFile();
                                                        }}
                                                        OnSendInvite={this.sendFaceAuthenticationInvite}
                                                        FaceRegistrationStatus={this.state.faceRegistrationInviteLinkStatus}
                                                        Limit={(this.props.IsAddRule || this.props.IsAddTemplate) ? 0 : this.props.Limit}
                                                        ContactNumbers={this.getSelectedContact()}
                                                    />
                                                </ClickAwayListener>
                                            </Popover>
                                        }
                                        {
                                            !this.state.sendOptInRequest && !this.props.IsSecureChat && !this.props.IsAddTemplate && !this.props.IsAddRule && (this.props.IsNewOrgFlow ? (this.props.UserPlanTracker.HasFaceVault && this.props.UserPlanTracker.HasAccessToSecureFiles) : (this.props.PlanMetrics?.HasAccessToFaceVault && this.props.PlanMetrics.HasAccessToSecureFiles)) && !this.props.GroupChat?.ID && !this.props.Campaign?.ID && this.props.Limit === 1 && (!!this.state.faceRegistrationInviteLinkStatus ? this.state.faceRegistrationInviteLinkStatus === FaceRegistrationInviteLinkStatus.Expired || this.state.faceRegistrationInviteLinkStatus === FaceRegistrationInviteLinkStatus.NotRegistered : true) && (
                                                <CustomTooltip title="Face Registration" placement="bottom">
                                                    <div className="my-auto">
                                                        <button ref={this.faceRef} tabIndex={15} data-up-arrow-index={301}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (Boolean(this.state.anchorFaceAuthentication)) {
                                                                    this.closeFaceAuthentication();
                                                                } else {
                                                                    this.openFaceAuthentication(e);
                                                                }
                                                            }}
                                                            onMouseEnter={() => { this.resetAllHoverStates("onFaceAuthenticationHover") }}
                                                            onMouseLeave={() => { this.resetAllHoverStates() }}
                                                        >
                                                            {this.state.onFaceAuthenticationHover || !!this.state.anchorFaceAuthentication ? (<FaceAuthenticationHoverIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />) : (<FaceAuthenticationIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />)}
                                                        </button>
                                                    </div>
                                                </CustomTooltip>
                                            )
                                        }
                                        {this.props.SignatureSettings?.Settings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() === "true" && !this.props.IsSecureChat && !this.props.IsNewMessage &&
                                            <CustomTooltip title='Falkon AI' placement='bottom'>
                                                <div className='my-auto' tabIndex={16}>
                                                    <button tabIndex={15} data-up-arrow-index={300} onClick={(e) => { this.handleAIfeaturesPopOver() }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onAiFeaturesHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {
                                                            (this.state.aiFeaturesPopUp || this.state.onAiFeaturesHover) ? <RefineMessageComposerActiveicon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} onClick={() => { this.handleAIfeaturesPopOver(); }} /> : <RefineMessageComposerDisableicon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} onClick={() => { this.handleAIfeaturesPopOver(); }} />
                                                        }
                                                    </button>
                                                    {/* {this.state.aiFeaturesPopUp ?
                                                <RefineMessageComposerActiveicon className='pr-1 py-1 c-pointer' onClick={() => { this.handleAIfeaturesPopOver(); }} />
                                                :
                                                <RefineMessageComposerDisableicon className='pr-1 py-1 c-pointer' onClick={() => { this.handleAIfeaturesPopOver(); }} />
                                            } */}
                                                </div>
                                            </CustomTooltip>
                                        }
                                        {!this.props.IsSecureChat && !this.props.IsNewMessage && !this.props.IsAfterHours && !this.props.Campaign?.ID && !this.props.GroupChat?.ID &&
                                            <CustomTooltip title='Notes' placement='bottom'>
                                                <div className='my-auto' tabIndex={17}>
                                                    <button type="button" tabIndex={15} data-up-arrow-index={302}
                                                        onClick={() => { this.openInternalNoteMode(); }}
                                                        onMouseEnter={() => { this.debouncedHoverReset("onNotesHover") }}
                                                        onMouseLeave={() => { this.debouncedHoverReset() }}
                                                    >
                                                        {this.state.onNotesHover ? <ComposerNotesActiveIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} /> : <ComposerNotesIcon className={`c-pointer ${this.props.IsMobileDevice ? "pr-10px py-1" : "p-1"} `} />}
                                                    </button>
                                                </div>
                                            </CustomTooltip>
                                        }
                                    </div>
                                    <div className='d-flex '>
                                        {(this.props.IsGroupChat || this.props.IsAfterHours) ? null :
                                            !this.props.GroupChat?.ID && ((this.props.IsNewOrgFlow ? this.props.UserPlanTracker.HasMessageScheduling : this.props.PlanMetrics.HasMessageScheduling) &&
                                                (!this.props.IsAddRule && !this.props.IsAddTemplate)) ?

                                                (this.state.showScheduleType && !this.props.IsMobileDevice) ?
                                                    <div className={`d-flex bg-color-con-hist-outbound-msg-bg br-5 h-4 justify-center align-center ${this.props.IsNewMessage ? "mr-0" : "mr-2"} my-auto`} ref={this.calenderRef}>
                                                        <Select
                                                            value={this.state.SelectedScheduleType}
                                                            onChange={this.handleSelectChange}
                                                            variant="standard"
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left",
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                            }}
                                                            renderValue={(selected) => {
                                                                const selectedOption = (this.props.IsSecureChat ? SecureScheduleTypes : ScheduleTypes)?.find(x => x.Value === selected);
                                                                return (
                                                                    <div className="d-flex ml-1 h4-regular color-primary-accent align-center">
                                                                        {selectedOption?.Name}
                                                                    </div>
                                                                );
                                                            }}
                                                        >
                                                            {(this.props.IsSecureChat ? SecureScheduleTypes : ScheduleTypes).map(option => (
                                                                <MenuItem key={option.Value} value={option.Value} className='h-4 px-1 d-flex justify-center h5-regular color-primary-accent'>
                                                                    {option.Name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        <div className="schedule-selected-verticle"></div>
                                                        <div
                                                            onClick={() => this.showClander(true)}
                                                            className='h5-regular t-align-left ml-1'>
                                                            {this.state.ScheduleDateTime !== -1 ? moment(this.state.ScheduleDateTime).format('MMMM Do YYYY HH:mm') : "MM DD YYYY HH"}
                                                        </div>

                                                        <div>
                                                            {
                                                                this.state.ScheduleDateTime !== -1 ?
                                                                    <Tooltip title='Reset Date' placement='bottom'>
                                                                        <button tabIndex={14}>
                                                                            <ResetIcon
                                                                                onClick={() => { this.handleCloseSchedule(); }}
                                                                                className={`c-pointer px-1`} />
                                                                        </button>
                                                                    </Tooltip>
                                                                    : <Tooltip title='Schedule Later' placement='bottom'>
                                                                        <button tabIndex={14}>
                                                                            <AlarmActive
                                                                                className={`c-pointer px-1`}
                                                                                onClick={() => {
                                                                                    this.props.IsMobileDevice ? this.props.setIsMobileSchedule(true) : this.ToggleScheduleDatetime()
                                                                                }}>
                                                                            </AlarmActive>
                                                                        </button>
                                                                    </Tooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    : (this.props.IsMobileDevice && this.state.ScheduleDateTime !== -1) ?
                                                        <div className='d-flex align-center'>
                                                            <div onClick={() => { this.props.setIsMobileSchedule(true) }}>
                                                                <AlarmActive className={`c-pointer br-5 p-1 ${this.props.IsNewMessage || this.props.IsMobileDevice ? "mr-0" : "mr-2"}`} />
                                                            </div>
                                                            <div onClick={() => { this.handleCloseSchedule(); this.props.setIsMobileSchedule(false) }}>
                                                                <ResetIcon className={`c-pointer pl-1 mr-0`} />
                                                            </div>
                                                        </div>
                                                        :
                                                        <Tooltip title='Schedule Later' placement='bottom'>
                                                            <button tabIndex={14} onClick={() => { this.props.IsMobileDevice ? this.props.setIsMobileSchedule(true) : this.ToggleScheduleDatetime() }}>
                                                                {this.state.ScheduleDateTime !== -1 ?
                                                                    <AlarmActive className={`c-pointer p-1 br-5 ${this.props.IsNewMessage || this.props.IsMobileDevice ? "mr-0" : "mr-2"}`} />
                                                                    :
                                                                    <ComposerTimerIcon className={`${this.props.IsNewMessage || this.props.IsMobileDevice ? "mr-0" : "mr-2"} ${this.props.IsNewMessage ? "c-pointer p-1  br-5" : `c-pointer p-1 br-5`}`} />
                                                                }
                                                            </button>
                                                        </Tooltip>
                                                : null
                                        }
                                        {
                                            this.state.showCalnder &&
                                            <DateAndTimePicker
                                                isMessage={this.state.showCalnder}
                                                CloseCalender={() => {
                                                    this.showClander(false);
                                                }}
                                                event={this.calenderRef}
                                                handleChange={this.handleScheduleTimeDate}
                                                handleEndChange={this.handleScheduleEndTimeDate}
                                                DateTime={this.state.ScheduleDateTime}
                                                EndDateTime={this.state.ScheduleEndDateTime}
                                                ShowStartEndTabs={!this.isOneTimeScheduleType()}
                                                IsMobileDevice={this.props.IsMobileDevice}
                                                DeviceWidth={this.props.DeviceWidth} />
                                        }
                                    </div>
                                    {!!this.props.TemplateErrorMessage && <FormHelperText className={`h5 color-primary-danger mt-1 t-align-right`}>
                                        {this.props.TemplateErrorMessage}
                                    </FormHelperText>}
                                </div>
                            </div>
                            <div className={`${this.props.IsNewMessage ? "" : this.props.IsMobileDevice ? "d-flex" : "d-flex border-top"}`}>
                                <div className={`d-flex flex-direction w-fill h4-regular px-2 py-1 h-v-12 o-y-scroll ${this.props.IsNewMessage ? "RichEditor-root-border br-4" : ""} ${this.props.IsMobileDevice ? this.props.IsNewMessage ? "" : `${this.props.isDarkMode ? "" : "bg-color-secondary"}  RichEditor-root-border br-2 mx-2 ${UtilityService.isIPhone(navigator.userAgent) ? "mb-2" : "mb-1"}` : ""}`}>
                                    <Mentions
                                        id={this.props.IsNewMessage ? "insert-tag-new-mentions" : "insert-tag-mentions"}
                                        body={this.state.body}
                                        isTemplate={this.state.isTemplate}
                                        tags={this.props.IsSecureChat ? [] : this.getResolvedTags()}
                                        placeholder={"Write a message..."}
                                        emoji={this.state.emoji}
                                        openTags={this.state.openTags}
                                        tagTarget={this.props.IsSecureChat ? undefined : this.tagRef?.current}
                                        onKeyDown={this.HandleKeyDown}
                                        closeTags={this.CloseInsertTagPortal}
                                        onChange={this.onBodyChange}
                                        maxLength={960}
                                        IsMobileDevice={this.props.IsMobileDevice}
                                        deviceHeight={this.props.DeviceHeight}
                                        IsNewMessage={this.props.IsNewMessage}
                                        IsAddRule={this.props.IsAddRule}
                                        IsGroupChat={!!this.props.IsGroupChat || !!this.props.GroupChat?.ID}
                                        onBlur={this.HandleBlur}
                                        phoneNumbers={this.props.PhoneNumbers}
                                        handleMedia={this.handleMediaChange}
                                        PopoverAnchor={this.state.popoverAnchor}
                                    />
                                    {this.state.showSign && !this.props.IsAddRule && !this.props.IsAddTemplate &&
                                        <div>
                                            <Mentions
                                                id={this.props.IsNewMessage ? "insert-tag-new-mentions-signature" : "insert-tag-mentions-signature"}
                                                body={this.state.bodySign}
                                                tags={this.getResolvedTags()}
                                                emoji={""}
                                                placeholder={this.state.defaultSign}
                                                openTags={false}
                                                tagTarget={this.tagRef?.current}
                                                onKeyDown={this.HandleKeyDown}
                                                closeTags={this.CloseInsertTagPortal}
                                                onChange={this.onSignatureChange}
                                                maxLength={30}
                                                IsAddRule={this.props.IsAddRule}
                                                IsGroupChat={this.props.IsGroupChat || !!this.props.GroupChat?.ID}
                                            />
                                        </div>
                                    }
                                    {!!this.state.files?.length && (
                                        (this.props.IsSecureChat) ?
                                            <div className={` d-flex flex-direction ${(this.props.IsMobileDevice ? "w-p-72 min-h-4 h-4 pt-1" : "min-h-6 h-6 pt-1 pb-1")}`}>
                                                {this.state.files.map((x, index) => (<div className="h-p-100 d-flex flex-direction justify-center br-2 mr-auto upload-media p-relative mb-1">
                                                    <div className='h-p-100 d-flex align-center px-1'>
                                                        <div className="w-4 h-4 d-flex align-center justify-center br-4 o-hidden">
                                                            {this.getSecureChatMediaComponent(x.media.ContentType, x.media)}
                                                        </div>
                                                        <div className={`d-flex align-center h5-medium px-1 w-space`}>
                                                            {!!x.media.Name && x.media.Name.slice(0, 40) + (x.media.Name.length > 40 ? "..." : "")}
                                                        </div>
                                                        <div className="d-flex justify-center align-center ">
                                                            {!this.state.mediaUploading.Status && <CancelIcon
                                                                className={"c-pointer ml-2 w-2"}
                                                                onClick={() => this.closeMedia(index)}
                                                            />
                                                            }
                                                        </div>
                                                    </div>
                                                    {this.state.mediaUploading.Status &&
                                                        <div className='p-absolute d-flex align-center h-1 mr-1'>
                                                            <AnimateLoaderComponent LoaderAnimation={SecureChatMediaUploading} className={"h-1 mt-2"} />
                                                        </div>
                                                    }
                                                </div>))
                                                }
                                            </div>
                                            :
                                            <div className={"p-1"}>
                                                {this.state.files.map((x, index) => (
                                                    <div className='d-flex mt-1 align-center'>
                                                        {
                                                            (x.media.ContentType === MediaType.IMAGE_JPEG || x.media.ContentType === MediaType.IMAGE || x.media.ContentType === MediaType.IMAGE_GIF || x.media.ContentType === MediaType.IMAGE_PNG || x.media.ContentType === MediaType.IMAGE_TIFF || x.media.ContentType === MediaType.IMAGE_ARW || x.media.ContentType === MediaType.IMAGE_WEBP || x.media.ContentType === MediaType.IMAGE_SVG || x.media.ContentType === MediaType.VIDEO || x.media.ContentType === MediaType.AUDIO || x.media.ContentType === MediaType.AUDIO_MP3 || x.media.ContentType === MediaType.AUDIO_MPeg || x.media.ContentType === MediaType.VIDEO_MP4) &&
                                                            <CancelIcon className={"c-pointer c-pointer mx-1"}
                                                                onClick={() => this.closeMedia(index)} />
                                                        }
                                                        {this.getComponent(x.media.ContentType, x, index)}
                                                    </div>
                                                ))}
                                            </div>
                                    )
                                    }
                                </div>
                                {
                                    (!this.props.IsNewMessage && !this.props.IsAddTemplate && !this.props.IsAddRule && !this.props.IsAfterHours) &&
                                    <div className={`mr-1 my-auto`}>
                                        <ButtonComponent
                                            buttonProps={{ tabIndex: 12 }}
                                            Loading={this.state.sendingNewMessage}
                                            HideLoader={!this.props.IsNewMessage}
                                            Variant={(this.IsMessageValid() && !this.state.sendOptInRequest) ? "primary-btn" : "disabled-btn"}
                                            Type={"submit"}
                                            OnClick={() => {
                                                if (this.props.IsAfterHours) {
                                                    this.props.AfterHoursClick();
                                                } else {
                                                    this.sendMessage();
                                                }
                                                if (this.props.HandleClose) {
                                                    this.props.HandleClose();
                                                }
                                            }}
                                            ClassName={`c-pointer px-2 py-1 send-btn-circle ${!this.props.IsMobileDevice && "ml-1"}  justify-center pl-1`}
                                            ButtonLabel={""}
                                            Icon={this.props.IsNewMessage ? SendNewMsgIcon : SendWhiteIcon}
                                            IconToolTip={appNote.MESSAGE_SEND_TOOL_TIP}
                                        />
                                        {(this.props.IsMobileDevice && !this.props.IsNewMessage && !this.props.IsSecureChat) && (
                                            <div>
                                                <p className={` ${this.props.isDarkMode ? "" : "editor-bottom-text-mobile"}  m-0`}>{`${this.getMessageLength()}/${this.state.characterLimit}`}</p>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>
                        </Fragment>
                    </div >
                )
                }

                {
                    !this.state.internalNoteMode && !this.props.IsSecureChat && (!this.props.IsMobileDevice || (this.props.IsMobileDevice && (this.props.IsNewMessage || this.props.IsAfterHours))) ? (
                        <div className={`d-flex align-center h5-regular ${this.props.IsNewMessage ? "justify-flex-start ml-1"
                            : "justify-flex-end "} ${this.props.IsAfterHoursActive ? 'disabled bg-color-settings-background' : ''}`}>
                            <p className={`pr-1 ${this.props.isDarkMode ? "" : "color-con-hist-msg-date"}`}>{`Characters: ${this.getMessageLength()}/${this.state.displayCharacterLimit} (${this.state.isGSM ? "GSM" : "UCS"})`}</p>
                            <p className={`pr-1 ${this.props.isDarkMode ? "" : "color-con-hist-msg-date"}`}>
                                {(this.state.characterLimit === 160 || this.state.characterLimit === 70) ? `Type: Short ${this.props.IsMobileDevice ? "" : " Message"}` : `Parts: ${this.getMessageParts()}/6`
                                }
                            </p>
                            {!this.props.IsSecureChat && (!this.props.IsAddTemplate || this.props.IsAfterHours) && (
                                <p className={`pr-1 ${this.props.isDarkMode ? "" : "color-con-hist-msg-date"}`}>{`Credits Required: ${this.handleCredits()}`}</p>
                            )}
                            {!this.props.IsMobileDevice && (
                                <Tooltip
                                    placement="top-start"
                                    arrow
                                    title={
                                        this.handleCredits() > 0 ? (
                                            CreditsRequried(
                                                this.props.Limit,
                                                this.getMessageLength(),
                                                this.getMessageParts(),
                                                this.handleCredits(),
                                                this.props.UnsubscribedCount,
                                                this.props.BlockedCount,
                                                !!this.props.GroupChat?.ID || this.props.IsGroupChat ? true : false,
                                                this.props.IsAddTemplate,
                                                this.props.IsAddRule
                                            )
                                        ) : (
                                            <span className={"h6-regular f-w-bold"}>
                                                Credits Required is calculated based on the number of
                                                contacts that are added and the number of characters in the
                                                message.
                                            </span>
                                        )
                                    }
                                >
                                    <ComposerHelpCircleIcon className={`c-pointer mr-2`} />
                                </Tooltip>
                            )}
                        </div>
                    ) : (
                        <span className={`${this.props.IsMobileDevice ? "" : "pb-1"}`}></span>
                    )
                }
                {
                    !this.props.IsGroupChat && this.props.Limit > 1 && this.props.IsNewMessage && <div className='d-flex px-1 w-p-95 mx-auto align-center br-1 mb-2 py-1 b-around-consent-message-border color-button-text bg-color-consent-message-bg'>
                        <InfoCircleIcon className={`w-p-10 ${this.props.IsMobileDevice ? "mr-1" : ""}`} />
                        <div className=''>
                            <div className='h4-medium'>Consent Confirmation</div>
                            <div className='h5-regular'>By clicking send, you confirm you have obtained consent to send messages to all campaign contacts listed above in accordance with compliance regulations.</div>
                        </div>
                    </div>
                }
                {
                    (this.props.IsNewMessage && this.props.IsMobileDevice && this.state.ScheduleDateTime !== -1) && (
                        <div className={`d-flex align-center h5-regular ${this.props.IsNewMessage ? "justify-flex-start ml-1"
                            : "justify-flex-end "}`}>
                            <p className="pr-1 color-con-hist-msg-date mt-0">{`Schedule Type: ${ScheduleTypes[this.state.SelectedScheduleType].Name}`}</p>
                            <p className="pr-1 color-con-hist-msg-date mt-0">{`Time: ${moment(this.state.ScheduleDateTime).format('MMMM Do YYYY HH:mm')}`}</p>
                        </div>
                    )
                }
                {
                    (!this.props.IsAddRule && this.props.IsNewMessage && !this.props.IsAddTemplate) &&
                    <div className={`${(this.props.IsNewMessage) ? `d-flex  ${this.props.IsMobileDevice ? "flex-direction-row justify-around" : "justify-flex-end"}` : 'mr-1 my-auto'}`}>
                        <ButtonComponent
                            buttonProps={{ tabIndex: this.state.showScheduleType ? 20 : 17 }}
                            Variant="secondary-btn-small"
                            ClassName={`mr-1 ${this.props.IsMobileDevice ? "w-v-50" : ""}`}
                            OnClick={() => this.props.HandleClose && this.props.HandleClose()}
                            ButtonLabel={buttonLabels.CANCEL}
                        />
                        <ButtonComponent
                            buttonProps={{ tabIndex: this.state.showScheduleType ? 19 : 16 }}
                            Loading={this.state.sendingNewMessage}
                            HideLoader={!this.props.IsNewMessage}
                            Variant={(this.IsMessageValid() && !this.state.sendOptInRequest) ? "primary-btn-small" : "disabled-btn-small"}
                            Type={"submit"}
                            OnClick={() => this.sendMessage()}
                            ClassName={`c-pointer ${`${this.props.IsMobileDevice ? "w-v-50" : ""}`} mr-1`}
                            ButtonLabel={(this.state.showScheduleType) ? "Schedule" : this.state.ScheduleDateTime === -1 ? "Send" : "Schedule"} Icon={this.props.IsNewMessage ? SendNewMsgIcon : SendWhiteIcon}
                            IconToolTip={appNote.MESSAGE_SEND_TOOL_TIP}
                        />
                    </div>
                }
                {
                    Boolean(this.state.anchorEmjoi) &&
                    <Popover
                        open={Boolean(this.state.anchorEmjoi)}
                        anchorEl={this.state.anchorEmjoi}
                        onClose={() => this.setState({ anchorEmjoi: null, onEmojiHover: false })}
                        anchorOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'bottom',
                            horizontal: 'right',
                        } : {
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'top',
                            horizontal: 'center',
                        } : {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                    >
                        <Emojis handleEmojiSelect={this.handleEmojiSelect} />
                    </Popover>
                }
                {
                    this.state.anchorFaceAuthentication && (
                        <Popover
                            open={Boolean(this.state.anchorFaceAuthentication)}
                            anchorEl={this.state.anchorFaceAuthentication}
                            onClose={() => this.setState({ anchorFaceAuthentication: null, onFaceAuthenticationHover: false })}

                            anchorOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                                vertical: 'bottom',
                                horizontal: 'center',
                            } : {
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                                vertical: 'top',
                                horizontal: 'center',
                            } : {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            classes={{ paper: `${this.props.IsMobileDevice ? "" : "w-p-14"}` }}
                        >
                            <ClickAwayListener onClickAway={() => this.setState({ anchorFaceAuthentication: null, onFaceAuthenticationHover: false })}>
                                <div className={`d-flex flex-direction align-center ${this.props.isDarkMode ? "bg-color-sidebar-bg" : ""}`} style={{ padding: '1rem' }}>
                                    <div className='h4-semibold mt-1 color-template-title d-flex justify-center t-align-center'>Face Registration</div>
                                    <div className='my-2'><FaceRegistrationIcon /></div>
                                    <ButtonComponent
                                        OnClick={() => this.sendFaceAuthenticationInvite()}
                                        ButtonLabel={buttonLabels.SEND_INVITE}
                                        ClassName={"mb-1"}
                                        Variant={"primary-btn-small"}
                                        Loading={this.state.sendInviteLoading}
                                    />
                                </div>
                            </ClickAwayListener>
                        </Popover>
                    )
                }
                {
                    (!this.props.IsMobileDevice || !this.props.IsNewMessage || this.props.IsNewMessage) && Boolean(this.state.anchorTemplate) &&
                    <Popover open={Boolean(this.state.anchorTemplate)}
                        anchorEl={this.state.anchorTemplate}
                        onClose={this.onCloseshowTemplates}
                        style={this.props.IsMobileDevice && window.innerHeight !== this.props.DeviceHeight
                            && (UtilityService.isAndroid(navigator.userAgent) || UtilityService.isIPhone(navigator.userAgent)) ? {
                            top: this.props.DeviceHeight - 400,
                        } : {}}
                        anchorOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'bottom',
                            horizontal: 'center',
                        } : {
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={this.props.IsMobileDevice && this.props.IsNewMessage ? {
                            vertical: 'top',
                            horizontal: 'center',
                        } : {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        classes={{ paper: `${this.props.IsMobileDevice ? "" : "w-p-20"}` }}
                    >
                        <div className={`h-v-40 d-flex flex-direction o-hidden p-1 ${this.props.isDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                            <div className={` color-display-title d-flex justify-around `} id="customized-dialog-title">
                                <div className=' h4-semibold mr-auto color-template-title'>Templates</div><div>
                                    <Link to={AppRoutes.TEMPLATES}>
                                        <div className=' h5-regular ml-auto color-template-link t-decoration-underline float-right'>Go to templates</div>
                                    </Link>
                                </div>
                            </div>
                            <div
                                className={`px-1 my-1`}>
                                <TextField
                                    inputProps={{
                                        tabIndex: 4,
                                        "data-arrow-index": 200,
                                    }}
                                    fullWidth
                                    placeholder={"Find a Template..."}
                                    onChange={this.searchTemplates}
                                    variant="outlined"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIconSec />
                                            </InputAdornment>
                                        ),
                                        classes: {
                                            input: "h5-regular color-text-field-font",
                                            notchedOutline: "br-8",
                                        },
                                    }}
                                    size="small"
                                />
                            </div>
                            <div className='o-y-auto o-x-hidden'>
                                <>
                                    {filteredTemplates.filter(x => x.IsPrivate).length === 0 ? "" : <div className='h5-semibold color-template-link px-1'>Private</div>}
                                    {filteredTemplates && filteredTemplates.filter(x => {
                                        const excludedPlaceholders = [
                                            "{{_MyFirstName_}}",
                                            "{{_MyLastName_}}",
                                            "{{_MyEmail_}}"
                                        ];
                                        return (
                                            x.IsPrivate && !x.IsPhoneNumberLevel
                                            && (this.props.IsAddRule === true ?
                                                excludedPlaceholders.every(
                                                    placeholder => !x.Message.includes(placeholder)
                                                ) : true)
                                        );
                                    }).map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1' onClick={() => { this.handleTemplateClick(template); this.onCloseshowTemplates() }}>
                                            <div className='h5-semibold w-break'>
                                                {template.Title}
                                            </div>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                <Mentions body={this.trimMessage(template.Message, 40)} tags={this.getResolvedTags()} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={template.Message.length} id={''} placeholder={''} readOnly={true} />
                                                <div className='ml-auto my-auto pl-1'>{!!template.Media?.length && <MediaDefaultIcon className={"w-3 h-3"} />}</div>
                                            </div>
                                        </div>
                                    )}
                                </>
                                <>
                                    {filteredTemplates.filter(x => x.IsPhoneNumberLevel).length === 0 ? "" : <div className='h5-semibold color-template-link px-1'>Phone Line</div>}
                                    {filteredTemplates.filter(x => {
                                        const excludedPlaceholders = [
                                            "{{_MyFirstName_}}",
                                            "{{_MyLastName_}}",
                                            "{{_MyEmail_}}"
                                        ];
                                        return (
                                            !x.IsPrivate && x.IsPhoneNumberLevel
                                            && (this.props.IsAddRule === true ?
                                                excludedPlaceholders.every(
                                                    placeholder => !x.Message.includes(placeholder)
                                                ) : true)
                                        );
                                    }).map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1' onClick={() => { this.handleTemplateClick(template); this.onCloseshowTemplates() }}>
                                            <div className='h5-semibold w-break'>
                                                {template.Title}
                                            </div>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                <Mentions body={this.trimMessage(template.Message, 40)} tags={this.getResolvedTags()} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={template.Message.length} id={''} placeholder={''} readOnly={true} />
                                                <div className='ml-auto my-auto pl-1'>{!!template.Media?.length && <MediaDefaultIcon className={"w-3 h-3"} />}</div>
                                            </div>
                                        </div>
                                    )}
                                </>
                                <>
                                    {filteredTemplates.filter(x => !x.IsPrivate && !x.IsPhoneNumberLevel).length === 0 ? "" : <div className='h5-semibold color-template-link px-1'>Organization</div>}
                                    {filteredTemplates.filter(x => {
                                        const excludedPlaceholders = [
                                            "{{_MyFirstName_}}",
                                            "{{_MyLastName_}}",
                                            "{{_MyEmail_}}"
                                        ];
                                        return (
                                            !x.IsPrivate && !x.IsPhoneNumberLevel
                                            && (this.props.IsAddRule === true ?
                                                excludedPlaceholders.every(
                                                    placeholder => !x.Message.includes(placeholder)
                                                ) : true)
                                        );
                                    }).map((template) =>
                                        <div className='mb-1 c-pointer grid-row p-1' onClick={() => { this.handleTemplateClick(template); this.onCloseshowTemplates() }}>
                                            <div className='h5-semibold w-break'>
                                                {template.Title}
                                            </div>
                                            <div className='d-flex bg-color-template-background  h5-regular p-1 payment-status-word'>
                                                <Mentions body={this.trimMessage(template.Message, 40)} tags={this.getResolvedTags()} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={template.Message.length} id={''} placeholder={''} readOnly={true} />
                                                <div className='ml-auto my-auto pl-1'>{!!template.Media?.length && <MediaDefaultIcon className={"w-3 h-3"} />}</div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </Popover>
                }
            </div >
        )
    }

    handleScheduleTimeDate = (scheduleTimeDate: number) => {
        this.setState({
            ScheduleDateTime: scheduleTimeDate
        })
    }

    handleScheduleEndTimeDate = (scheduleEndTimeDate: number) => {
        console.log(UtilityService.convertToLocalTimeZone(scheduleEndTimeDate), UtilityService.convertToLocalTimeZone(scheduleEndTimeDate).toISOString())
        this.setState({
            ScheduleEndDateTime: scheduleEndTimeDate
        })
    }

    ResetDateTime = () => {
        this.setState({ ScheduleDateTime: -1, ScheduleEndDateTime: -1 })
    }
}

const mapStateToProps = (state: AppState): IStateProps => {
    return {
        IsMobileDevice: state.IsMobileDevice,
        DeviceWidth: state.DeviceWidth,
        DeviceHeight: state.DeviceHeight,
        PlanMetrics: state.PlanMetrics,
        Contacts: state.Contacts,
        Groups: state.Groups,
        Templates: state.Templates,
        SignatureSettings: state.Settings,
        GetUnSubscribedContacts: state.GetUnSubscribedContacts,
        SecureFile: state.SecureFiles,
        UnscbscribedConversations: state.Conversations.filter(x => x.IsUnsubscribed),
        FaceAuthenticationFiles: state.FaceAuthenticationFiles,
        FalkonWebSocket: state.FalkonWebSocket,
        History: state.History,
        isDarkMode: state.isDarkMode,
        IsNewOrgFlow: state.IsNewOrgFlow,
        UserPlanTracker: state.UserPlanTracker,
        OrgPlanTracker: state.OrgPlanTracker,
        Conversations: state.Conversations,
        OptInCollectedMessage: state.OptInCollectedMessage,
        customAttributeFields: state.CustomAttributeDefinitions ?? [],
        Users: state.Users,
        OrganizationName: state.OrganizationName
    }
}

export default connect(mapStateToProps)(MessageComposer);